var items = {
  "block.minecraft.acacia_button": "Acacia Button",
  "block.minecraft.acacia_door": "Acacia Door",
  "block.minecraft.acacia_fence": "Acacia Fence",
  "block.minecraft.acacia_fence_gate": "Acacia Fence Gate",
  "block.minecraft.acacia_hanging_sign": "Acacia Hanging Sign",
  "block.minecraft.acacia_leaves": "Acacia Leaves",
  "block.minecraft.acacia_log": "Acacia Log",
  "block.minecraft.acacia_planks": "Acacia Planks",
  "block.minecraft.acacia_pressure_plate": "Acacia Pressure Plate",
  "block.minecraft.acacia_sapling": "Acacia Sapling",
  "block.minecraft.acacia_shelf": "Acacia Shelf",
  "block.minecraft.acacia_sign": "Acacia Sign",
  "block.minecraft.acacia_slab": "Acacia Slab",
  "block.minecraft.acacia_stairs": "Acacia Stairs",
  "block.minecraft.acacia_trapdoor": "Acacia Trapdoor",
  "block.minecraft.acacia_wall_hanging_sign": "Acacia Wall Hanging Sign",
  "block.minecraft.acacia_wall_sign": "Acacia Wall Sign",
  "block.minecraft.acacia_wood": "Acacia Wood",
  "block.minecraft.activator_rail": "Activator Rail",
  "block.minecraft.air": "Air",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Block of Amethyst",
  "block.minecraft.amethyst_cluster": "Amethyst Cluster",
  "block.minecraft.ancient_debris": "Ancient Debris",
  "block.minecraft.andesite": "Andesite",
  "block.minecraft.andesite_slab": "Andesite Slab",
  "block.minecraft.andesite_stairs": "Andesite Stairs",
  "block.minecraft.andesite_wall": "Andesite Wall",
  "block.minecraft.anvil": "Anvil",
  "block.minecraft.attached_melon_stem": "Attached Melon Stem",
  "block.minecraft.attached_pumpkin_stem": "Attached Pumpkin Stem",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Azalea Leaves",
  "block.minecraft.azure_bluet": "Azure Bluet",
  "block.minecraft.bamboo": "Bamboo",
  "block.minecraft.bamboo_block": "Block of Bamboo",
  "block.minecraft.bamboo_button": "Bamboo Button",
  "block.minecraft.bamboo_door": "Bamboo Door",
  "block.minecraft.bamboo_fence": "Bamboo Fence",
  "block.minecraft.bamboo_fence_gate": "Bamboo Fence Gate",
  "block.minecraft.bamboo_hanging_sign": "Bamboo Hanging Sign",
  "block.minecraft.bamboo_mosaic": "Bamboo Mosaic",
  "block.minecraft.bamboo_mosaic_slab": "Bamboo Mosaic Slab",
  "block.minecraft.bamboo_mosaic_stairs": "Bamboo Mosaic Stairs",
  "block.minecraft.bamboo_planks": "Bamboo Planks",
  "block.minecraft.bamboo_pressure_plate": "Bamboo Pressure Plate",
  "block.minecraft.bamboo_sapling": "Bamboo Shoot",
  "block.minecraft.bamboo_shelf": "Bamboo Shelf",
  "block.minecraft.bamboo_sign": "Bamboo Sign",
  "block.minecraft.bamboo_slab": "Bamboo Slab",
  "block.minecraft.bamboo_stairs": "Bamboo Stairs",
  "block.minecraft.bamboo_trapdoor": "Bamboo Trapdoor",
  "block.minecraft.bamboo_wall_hanging_sign": "Bamboo Wall Hanging Sign",
  "block.minecraft.bamboo_wall_sign": "Bamboo Wall Sign",
  "block.minecraft.banner.base.black": "Fully Black Field",
  "block.minecraft.banner.base.blue": "Fully Blue Field",
  "block.minecraft.banner.base.brown": "Fully Brown Field",
  "block.minecraft.banner.base.cyan": "Fully Cyan Field",
  "block.minecraft.banner.base.gray": "Fully Grey Field",
  "block.minecraft.banner.base.green": "Fully Green Field",
  "block.minecraft.banner.base.light_blue": "Fully Light Blue Field",
  "block.minecraft.banner.base.light_gray": "Fully Light Grey Field",
  "block.minecraft.banner.base.lime": "Fully Lime Field",
  "block.minecraft.banner.base.magenta": "Fully Magenta Field",
  "block.minecraft.banner.base.orange": "Fully Orange Field",
  "block.minecraft.banner.base.pink": "Fully Pink Field",
  "block.minecraft.banner.base.purple": "Fully Purple Field",
  "block.minecraft.banner.base.red": "Fully Red Field",
  "block.minecraft.banner.base.white": "Fully White Field",
  "block.minecraft.banner.base.yellow": "Fully Yellow Field",
  "block.minecraft.banner.border.black": "Black Bordure",
  "block.minecraft.banner.border.blue": "Blue Bordure",
  "block.minecraft.banner.border.brown": "Brown Bordure",
  "block.minecraft.banner.border.cyan": "Cyan Bordure",
  "block.minecraft.banner.border.gray": "Grey Bordure",
  "block.minecraft.banner.border.green": "Green Bordure",
  "block.minecraft.banner.border.light_blue": "Light Blue Bordure",
  "block.minecraft.banner.border.light_gray": "Light Grey Bordure",
  "block.minecraft.banner.border.lime": "Lime Bordure",
  "block.minecraft.banner.border.magenta": "Magenta Bordure",
  "block.minecraft.banner.border.orange": "Orange Bordure",
  "block.minecraft.banner.border.pink": "Pink Bordure",
  "block.minecraft.banner.border.purple": "Purple Bordure",
  "block.minecraft.banner.border.red": "Red Bordure",
  "block.minecraft.banner.border.white": "White Bordure",
  "block.minecraft.banner.border.yellow": "Yellow Bordure",
  "block.minecraft.banner.bricks.black": "Black Field Masoned",
  "block.minecraft.banner.bricks.blue": "Blue Field Masoned",
  "block.minecraft.banner.bricks.brown": "Brown Field Masoned",
  "block.minecraft.banner.bricks.cyan": "Cyan Field Masoned",
  "block.minecraft.banner.bricks.gray": "Grey Field Masoned",
  "block.minecraft.banner.bricks.green": "Green Field Masoned",
  "block.minecraft.banner.bricks.light_blue": "Light Blue Field Masoned",
  "block.minecraft.banner.bricks.light_gray": "Light Grey Field Masoned",
  "block.minecraft.banner.bricks.lime": "Lime Field Masoned",
  "block.minecraft.banner.bricks.magenta": "Magenta Field Masoned",
  "block.minecraft.banner.bricks.orange": "Orange Field Masoned",
  "block.minecraft.banner.bricks.pink": "Pink Field Masoned",
  "block.minecraft.banner.bricks.purple": "Purple Field Masoned",
  "block.minecraft.banner.bricks.red": "Red Field Masoned",
  "block.minecraft.banner.bricks.white": "White Field Masoned",
  "block.minecraft.banner.bricks.yellow": "Yellow Field Masoned",
  "block.minecraft.banner.circle.black": "Black Roundel",
  "block.minecraft.banner.circle.blue": "Blue Roundel",
  "block.minecraft.banner.circle.brown": "Brown Roundel",
  "block.minecraft.banner.circle.cyan": "Cyan Roundel",
  "block.minecraft.banner.circle.gray": "Grey Roundel",
  "block.minecraft.banner.circle.green": "Green Roundel",
  "block.minecraft.banner.circle.light_blue": "Light Blue Roundel",
  "block.minecraft.banner.circle.light_gray": "Light Grey Roundel",
  "block.minecraft.banner.circle.lime": "Lime Roundel",
  "block.minecraft.banner.circle.magenta": "Magenta Roundel",
  "block.minecraft.banner.circle.orange": "Orange Roundel",
  "block.minecraft.banner.circle.pink": "Pink Roundel",
  "block.minecraft.banner.circle.purple": "Purple Roundel",
  "block.minecraft.banner.circle.red": "Red Roundel",
  "block.minecraft.banner.circle.white": "White Roundel",
  "block.minecraft.banner.circle.yellow": "Yellow Roundel",
  "block.minecraft.banner.creeper.black": "Black Creeper Charge",
  "block.minecraft.banner.creeper.blue": "Blue Creeper Charge",
  "block.minecraft.banner.creeper.brown": "Brown Creeper Charge",
  "block.minecraft.banner.creeper.cyan": "Cyan Creeper Charge",
  "block.minecraft.banner.creeper.gray": "Grey Creeper Charge",
  "block.minecraft.banner.creeper.green": "Green Creeper Charge",
  "block.minecraft.banner.creeper.light_blue": "Light Blue Creeper Charge",
  "block.minecraft.banner.creeper.light_gray": "Light Grey Creeper Charge",
  "block.minecraft.banner.creeper.lime": "Lime Creeper Charge",
  "block.minecraft.banner.creeper.magenta": "Magenta Creeper Charge",
  "block.minecraft.banner.creeper.orange": "Orange Creeper Charge",
  "block.minecraft.banner.creeper.pink": "Pink Creeper Charge",
  "block.minecraft.banner.creeper.purple": "Purple Creeper Charge",
  "block.minecraft.banner.creeper.red": "Red Creeper Charge",
  "block.minecraft.banner.creeper.white": "White Creeper Charge",
  "block.minecraft.banner.creeper.yellow": "Yellow Creeper Charge",
  "block.minecraft.banner.cross.black": "Black Saltire",
  "block.minecraft.banner.cross.blue": "Blue Saltire",
  "block.minecraft.banner.cross.brown": "Brown Saltire",
  "block.minecraft.banner.cross.cyan": "Cyan Saltire",
  "block.minecraft.banner.cross.gray": "Grey Saltire",
  "block.minecraft.banner.cross.green": "Green Saltire",
  "block.minecraft.banner.cross.light_blue": "Light Blue Saltire",
  "block.minecraft.banner.cross.light_gray": "Light Grey Saltire",
  "block.minecraft.banner.cross.lime": "Lime Saltire",
  "block.minecraft.banner.cross.magenta": "Magenta Saltire",
  "block.minecraft.banner.cross.orange": "Orange Saltire",
  "block.minecraft.banner.cross.pink": "Pink Saltire",
  "block.minecraft.banner.cross.purple": "Purple Saltire",
  "block.minecraft.banner.cross.red": "Red Saltire",
  "block.minecraft.banner.cross.white": "White Saltire",
  "block.minecraft.banner.cross.yellow": "Yellow Saltire",
  "block.minecraft.banner.curly_border.black": "Black Bordure Indented",
  "block.minecraft.banner.curly_border.blue": "Blue Bordure Indented",
  "block.minecraft.banner.curly_border.brown": "Brown Bordure Indented",
  "block.minecraft.banner.curly_border.cyan": "Cyan Bordure Indented",
  "block.minecraft.banner.curly_border.gray": "Grey Bordure Indented",
  "block.minecraft.banner.curly_border.green": "Green Bordure Indented",
  "block.minecraft.banner.curly_border.light_blue": "Light Blue Bordure Indented",
  "block.minecraft.banner.curly_border.light_gray": "Light Grey Bordure Indented",
  "block.minecraft.banner.curly_border.lime": "Lime Bordure Indented",
  "block.minecraft.banner.curly_border.magenta": "Magenta Bordure Indented",
  "block.minecraft.banner.curly_border.orange": "Orange Bordure Indented",
  "block.minecraft.banner.curly_border.pink": "Pink Bordure Indented",
  "block.minecraft.banner.curly_border.purple": "Purple Bordure Indented",
  "block.minecraft.banner.curly_border.red": "Red Bordure Indented",
  "block.minecraft.banner.curly_border.white": "White Bordure Indented",
  "block.minecraft.banner.curly_border.yellow": "Yellow Bordure Indented",
  "block.minecraft.banner.diagonal_left.black": "Black Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.blue": "Blue Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.brown": "Brown Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.cyan": "Cyan Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.gray": "Grey Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.green": "Green Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.light_blue": "Light Blue Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.light_gray": "Light Grey Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.lime": "Lime Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.orange": "Orange Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.pink": "Pink Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.purple": "Purple Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.red": "Red Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.white": "White Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.yellow": "Yellow Per Bend Sinister",
  "block.minecraft.banner.diagonal_right.black": "Black Per Bend",
  "block.minecraft.banner.diagonal_right.blue": "Blue Per Bend",
  "block.minecraft.banner.diagonal_right.brown": "Brown Per Bend",
  "block.minecraft.banner.diagonal_right.cyan": "Cyan Per Bend",
  "block.minecraft.banner.diagonal_right.gray": "Grey Per Bend",
  "block.minecraft.banner.diagonal_right.green": "Green Per Bend",
  "block.minecraft.banner.diagonal_right.light_blue": "Light Blue Per Bend",
  "block.minecraft.banner.diagonal_right.light_gray": "Light Grey Per Bend",
  "block.minecraft.banner.diagonal_right.lime": "Lime Per Bend",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta Per Bend",
  "block.minecraft.banner.diagonal_right.orange": "Orange Per Bend",
  "block.minecraft.banner.diagonal_right.pink": "Pink Per Bend",
  "block.minecraft.banner.diagonal_right.purple": "Purple Per Bend",
  "block.minecraft.banner.diagonal_right.red": "Red Per Bend",
  "block.minecraft.banner.diagonal_right.white": "White Per Bend",
  "block.minecraft.banner.diagonal_right.yellow": "Yellow Per Bend",
  "block.minecraft.banner.diagonal_up_left.black": "Black Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.blue": "Blue Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.brown": "Brown Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.cyan": "Cyan Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.gray": "Grey Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.green": "Green Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Light Blue Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Light Grey Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.lime": "Lime Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.orange": "Orange Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.pink": "Pink Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.purple": "Purple Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.red": "Red Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.white": "White Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.yellow": "Yellow Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_right.black": "Black Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.blue": "Blue Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.brown": "Brown Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.cyan": "Cyan Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.gray": "Grey Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.green": "Green Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Light Blue Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Light Grey Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.lime": "Lime Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.orange": "Orange Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.pink": "Pink Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.purple": "Purple Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.red": "Red Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.white": "White Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.yellow": "Yellow Per Bend Sinister Inverted",
  "block.minecraft.banner.flow.black": "Black Flow",
  "block.minecraft.banner.flow.blue": "Blue Flow",
  "block.minecraft.banner.flow.brown": "Brown Flow",
  "block.minecraft.banner.flow.cyan": "Cyan Flow",
  "block.minecraft.banner.flow.gray": "Grey Flow",
  "block.minecraft.banner.flow.green": "Green Flow",
  "block.minecraft.banner.flow.light_blue": "Light Blue Flow",
  "block.minecraft.banner.flow.light_gray": "Light Grey Flow",
  "block.minecraft.banner.flow.lime": "Lime Flow",
  "block.minecraft.banner.flow.magenta": "Magenta Flow",
  "block.minecraft.banner.flow.orange": "Orange Flow",
  "block.minecraft.banner.flow.pink": "Pink Flow",
  "block.minecraft.banner.flow.purple": "Purple Flow",
  "block.minecraft.banner.flow.red": "Red Flow",
  "block.minecraft.banner.flow.white": "White Flow",
  "block.minecraft.banner.flow.yellow": "Yellow Flow",
  "block.minecraft.banner.flower.black": "Black Flower Charge",
  "block.minecraft.banner.flower.blue": "Blue Flower Charge",
  "block.minecraft.banner.flower.brown": "Brown Flower Charge",
  "block.minecraft.banner.flower.cyan": "Cyan Flower Charge",
  "block.minecraft.banner.flower.gray": "Grey Flower Charge",
  "block.minecraft.banner.flower.green": "Green Flower Charge",
  "block.minecraft.banner.flower.light_blue": "Light Blue Flower Charge",
  "block.minecraft.banner.flower.light_gray": "Light Grey Flower Charge",
  "block.minecraft.banner.flower.lime": "Lime Flower Charge",
  "block.minecraft.banner.flower.magenta": "Magenta Flower Charge",
  "block.minecraft.banner.flower.orange": "Orange Flower Charge",
  "block.minecraft.banner.flower.pink": "Pink Flower Charge",
  "block.minecraft.banner.flower.purple": "Purple Flower Charge",
  "block.minecraft.banner.flower.red": "Red Flower Charge",
  "block.minecraft.banner.flower.white": "White Flower Charge",
  "block.minecraft.banner.flower.yellow": "Yellow Flower Charge",
  "block.minecraft.banner.globe.black": "Black Globe",
  "block.minecraft.banner.globe.blue": "Blue Globe",
  "block.minecraft.banner.globe.brown": "Brown Globe",
  "block.minecraft.banner.globe.cyan": "Cyan Globe",
  "block.minecraft.banner.globe.gray": "Grey Globe",
  "block.minecraft.banner.globe.green": "Green Globe",
  "block.minecraft.banner.globe.light_blue": "Light Blue Globe",
  "block.minecraft.banner.globe.light_gray": "Light Grey Globe",
  "block.minecraft.banner.globe.lime": "Lime Globe",
  "block.minecraft.banner.globe.magenta": "Magenta Globe",
  "block.minecraft.banner.globe.orange": "Orange Globe",
  "block.minecraft.banner.globe.pink": "Pink Globe",
  "block.minecraft.banner.globe.purple": "Purple Globe",
  "block.minecraft.banner.globe.red": "Red Globe",
  "block.minecraft.banner.globe.white": "White Globe",
  "block.minecraft.banner.globe.yellow": "Yellow Globe",
  "block.minecraft.banner.gradient.black": "Black Gradient",
  "block.minecraft.banner.gradient.blue": "Blue Gradient",
  "block.minecraft.banner.gradient.brown": "Brown Gradient",
  "block.minecraft.banner.gradient.cyan": "Cyan Gradient",
  "block.minecraft.banner.gradient.gray": "Grey Gradient",
  "block.minecraft.banner.gradient.green": "Green Gradient",
  "block.minecraft.banner.gradient.light_blue": "Light Blue Gradient",
  "block.minecraft.banner.gradient.light_gray": "Light Grey Gradient",
  "block.minecraft.banner.gradient.lime": "Lime Gradient",
  "block.minecraft.banner.gradient.magenta": "Magenta Gradient",
  "block.minecraft.banner.gradient.orange": "Orange Gradient",
  "block.minecraft.banner.gradient.pink": "Pink Gradient",
  "block.minecraft.banner.gradient.purple": "Purple Gradient",
  "block.minecraft.banner.gradient.red": "Red Gradient",
  "block.minecraft.banner.gradient.white": "White Gradient",
  "block.minecraft.banner.gradient.yellow": "Yellow Gradient",
  "block.minecraft.banner.gradient_up.black": "Black Base Gradient",
  "block.minecraft.banner.gradient_up.blue": "Blue Base Gradient",
  "block.minecraft.banner.gradient_up.brown": "Brown Base Gradient",
  "block.minecraft.banner.gradient_up.cyan": "Cyan Base Gradient",
  "block.minecraft.banner.gradient_up.gray": "Grey Base Gradient",
  "block.minecraft.banner.gradient_up.green": "Green Base Gradient",
  "block.minecraft.banner.gradient_up.light_blue": "Light Blue Base Gradient",
  "block.minecraft.banner.gradient_up.light_gray": "Light Grey Base Gradient",
  "block.minecraft.banner.gradient_up.lime": "Lime Base Gradient",
  "block.minecraft.banner.gradient_up.magenta": "Magenta Base Gradient",
  "block.minecraft.banner.gradient_up.orange": "Orange Base Gradient",
  "block.minecraft.banner.gradient_up.pink": "Pink Base Gradient",
  "block.minecraft.banner.gradient_up.purple": "Purple Base Gradient",
  "block.minecraft.banner.gradient_up.red": "Red Base Gradient",
  "block.minecraft.banner.gradient_up.white": "White Base Gradient",
  "block.minecraft.banner.gradient_up.yellow": "Yellow Base Gradient",
  "block.minecraft.banner.guster.black": "Black Guster",
  "block.minecraft.banner.guster.blue": "Blue Guster",
  "block.minecraft.banner.guster.brown": "Brown Guster",
  "block.minecraft.banner.guster.cyan": "Cyan Guster",
  "block.minecraft.banner.guster.gray": "Grey Guster",
  "block.minecraft.banner.guster.green": "Green Guster",
  "block.minecraft.banner.guster.light_blue": "Light Blue Guster",
  "block.minecraft.banner.guster.light_gray": "Light Grey Guster",
  "block.minecraft.banner.guster.lime": "Lime Guster",
  "block.minecraft.banner.guster.magenta": "Magenta Guster",
  "block.minecraft.banner.guster.orange": "Orange Guster",
  "block.minecraft.banner.guster.pink": "Pink Guster",
  "block.minecraft.banner.guster.purple": "Purple Guster",
  "block.minecraft.banner.guster.red": "Red Guster",
  "block.minecraft.banner.guster.white": "White Guster",
  "block.minecraft.banner.guster.yellow": "Yellow Guster",
  "block.minecraft.banner.half_horizontal.black": "Black Per Fess",
  "block.minecraft.banner.half_horizontal.blue": "Blue Per Fess",
  "block.minecraft.banner.half_horizontal.brown": "Brown Per Fess",
  "block.minecraft.banner.half_horizontal.cyan": "Cyan Per Fess",
  "block.minecraft.banner.half_horizontal.gray": "Grey Per Fess",
  "block.minecraft.banner.half_horizontal.green": "Green Per Fess",
  "block.minecraft.banner.half_horizontal.light_blue": "Light Blue Per Fess",
  "block.minecraft.banner.half_horizontal.light_gray": "Light Grey Per Fess",
  "block.minecraft.banner.half_horizontal.lime": "Lime Per Fess",
  "block.minecraft.banner.half_horizontal.magenta": "Magenta Per Fess",
  "block.minecraft.banner.half_horizontal.orange": "Orange Per Fess",
  "block.minecraft.banner.half_horizontal.pink": "Pink Per Fess",
  "block.minecraft.banner.half_horizontal.purple": "Purple Per Fess",
  "block.minecraft.banner.half_horizontal.red": "Red Per Fess",
  "block.minecraft.banner.half_horizontal.white": "White Per Fess",
  "block.minecraft.banner.half_horizontal.yellow": "Yellow Per Fess",
  "block.minecraft.banner.half_horizontal_bottom.black": "Black Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blue Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brown Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Cyan Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Grey Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.green": "Green Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Light Blue Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Light Grey Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Lime Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Magenta Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Orange Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Pink Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Purple Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.red": "Red Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.white": "White Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Yellow Per Fess Inverted",
  "block.minecraft.banner.half_vertical.black": "Black Per Pale",
  "block.minecraft.banner.half_vertical.blue": "Blue Per Pale",
  "block.minecraft.banner.half_vertical.brown": "Brown Per Pale",
  "block.minecraft.banner.half_vertical.cyan": "Cyan Per Pale",
  "block.minecraft.banner.half_vertical.gray": "Grey Per Pale",
  "block.minecraft.banner.half_vertical.green": "Green Per Pale",
  "block.minecraft.banner.half_vertical.light_blue": "Light Blue Per Pale",
  "block.minecraft.banner.half_vertical.light_gray": "Light Grey Per Pale",
  "block.minecraft.banner.half_vertical.lime": "Lime Per Pale",
  "block.minecraft.banner.half_vertical.magenta": "Magenta Per Pale",
  "block.minecraft.banner.half_vertical.orange": "Orange Per Pale",
  "block.minecraft.banner.half_vertical.pink": "Pink Per Pale",
  "block.minecraft.banner.half_vertical.purple": "Purple Per Pale",
  "block.minecraft.banner.half_vertical.red": "Red Per Pale",
  "block.minecraft.banner.half_vertical.white": "White Per Pale",
  "block.minecraft.banner.half_vertical.yellow": "Yellow Per Pale",
  "block.minecraft.banner.half_vertical_right.black": "Black Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.blue": "Blue Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.brown": "Brown Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.cyan": "Cyan Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.gray": "Grey Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.green": "Green Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.light_blue": "Light Blue Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.light_gray": "Light Grey Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.lime": "Lime Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.magenta": "Magenta Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.orange": "Orange Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.pink": "Pink Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.purple": "Purple Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.red": "Red Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.white": "White Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.yellow": "Yellow Per Pale Inverted",
  "block.minecraft.banner.mojang.black": "Black Thing",
  "block.minecraft.banner.mojang.blue": "Blue Thing",
  "block.minecraft.banner.mojang.brown": "Brown Thing",
  "block.minecraft.banner.mojang.cyan": "Cyan Thing",
  "block.minecraft.banner.mojang.gray": "Grey Thing",
  "block.minecraft.banner.mojang.green": "Green Thing",
  "block.minecraft.banner.mojang.light_blue": "Light Blue Thing",
  "block.minecraft.banner.mojang.light_gray": "Light Grey Thing",
  "block.minecraft.banner.mojang.lime": "Lime Thing",
  "block.minecraft.banner.mojang.magenta": "Magenta Thing",
  "block.minecraft.banner.mojang.orange": "Orange Thing",
  "block.minecraft.banner.mojang.pink": "Pink Thing",
  "block.minecraft.banner.mojang.purple": "Purple Thing",
  "block.minecraft.banner.mojang.red": "Red Thing",
  "block.minecraft.banner.mojang.white": "White Thing",
  "block.minecraft.banner.mojang.yellow": "Yellow Thing",
  "block.minecraft.banner.piglin.black": "Black Snout",
  "block.minecraft.banner.piglin.blue": "Blue Snout",
  "block.minecraft.banner.piglin.brown": "Brown Snout",
  "block.minecraft.banner.piglin.cyan": "Cyan Snout",
  "block.minecraft.banner.piglin.gray": "Grey Snout",
  "block.minecraft.banner.piglin.green": "Green Snout",
  "block.minecraft.banner.piglin.light_blue": "Light Blue Snout",
  "block.minecraft.banner.piglin.light_gray": "Light Grey Snout",
  "block.minecraft.banner.piglin.lime": "Lime Snout",
  "block.minecraft.banner.piglin.magenta": "Magenta Snout",
  "block.minecraft.banner.piglin.orange": "Orange Snout",
  "block.minecraft.banner.piglin.pink": "Pink Snout",
  "block.minecraft.banner.piglin.purple": "Purple Snout",
  "block.minecraft.banner.piglin.red": "Red Snout",
  "block.minecraft.banner.piglin.white": "White Snout",
  "block.minecraft.banner.piglin.yellow": "Yellow Snout",
  "block.minecraft.banner.rhombus.black": "Black Lozenge",
  "block.minecraft.banner.rhombus.blue": "Blue Lozenge",
  "block.minecraft.banner.rhombus.brown": "Brown Lozenge",
  "block.minecraft.banner.rhombus.cyan": "Cyan Lozenge",
  "block.minecraft.banner.rhombus.gray": "Grey Lozenge",
  "block.minecraft.banner.rhombus.green": "Green Lozenge",
  "block.minecraft.banner.rhombus.light_blue": "Light Blue Lozenge",
  "block.minecraft.banner.rhombus.light_gray": "Light Grey Lozenge",
  "block.minecraft.banner.rhombus.lime": "Lime Lozenge",
  "block.minecraft.banner.rhombus.magenta": "Magenta Lozenge",
  "block.minecraft.banner.rhombus.orange": "Orange Lozenge",
  "block.minecraft.banner.rhombus.pink": "Pink Lozenge",
  "block.minecraft.banner.rhombus.purple": "Purple Lozenge",
  "block.minecraft.banner.rhombus.red": "Red Lozenge",
  "block.minecraft.banner.rhombus.white": "White Lozenge",
  "block.minecraft.banner.rhombus.yellow": "Yellow Lozenge",
  "block.minecraft.banner.skull.black": "Black Skull Charge",
  "block.minecraft.banner.skull.blue": "Blue Skull Charge",
  "block.minecraft.banner.skull.brown": "Brown Skull Charge",
  "block.minecraft.banner.skull.cyan": "Cyan Skull Charge",
  "block.minecraft.banner.skull.gray": "Grey Skull Charge",
  "block.minecraft.banner.skull.green": "Green Skull Charge",
  "block.minecraft.banner.skull.light_blue": "Light Blue Skull Charge",
  "block.minecraft.banner.skull.light_gray": "Light Grey Skull Charge",
  "block.minecraft.banner.skull.lime": "Lime Skull Charge",
  "block.minecraft.banner.skull.magenta": "Magenta Skull Charge",
  "block.minecraft.banner.skull.orange": "Orange Skull Charge",
  "block.minecraft.banner.skull.pink": "Pink Skull Charge",
  "block.minecraft.banner.skull.purple": "Purple Skull Charge",
  "block.minecraft.banner.skull.red": "Red Skull Charge",
  "block.minecraft.banner.skull.white": "White Skull Charge",
  "block.minecraft.banner.skull.yellow": "Yellow Skull Charge",
  "block.minecraft.banner.small_stripes.black": "Black Paly",
  "block.minecraft.banner.small_stripes.blue": "Blue Paly",
  "block.minecraft.banner.small_stripes.brown": "Brown Paly",
  "block.minecraft.banner.small_stripes.cyan": "Cyan Paly",
  "block.minecraft.banner.small_stripes.gray": "Grey Paly",
  "block.minecraft.banner.small_stripes.green": "Green Paly",
  "block.minecraft.banner.small_stripes.light_blue": "Light Blue Paly",
  "block.minecraft.banner.small_stripes.light_gray": "Light Grey Paly",
  "block.minecraft.banner.small_stripes.lime": "Lime Paly",
  "block.minecraft.banner.small_stripes.magenta": "Magenta Paly",
  "block.minecraft.banner.small_stripes.orange": "Orange Paly",
  "block.minecraft.banner.small_stripes.pink": "Pink Paly",
  "block.minecraft.banner.small_stripes.purple": "Purple Paly",
  "block.minecraft.banner.small_stripes.red": "Red Paly",
  "block.minecraft.banner.small_stripes.white": "White Paly",
  "block.minecraft.banner.small_stripes.yellow": "Yellow Paly",
  "block.minecraft.banner.square_bottom_left.black": "Black Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.blue": "Blue Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.brown": "Brown Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.cyan": "Cyan Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.gray": "Grey Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.green": "Green Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.light_blue": "Light Blue Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.light_gray": "Light Grey Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.lime": "Lime Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.magenta": "Magenta Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.orange": "Orange Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.pink": "Pink Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.purple": "Purple Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.red": "Red Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.white": "White Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.yellow": "Yellow Base Dexter Canton",
  "block.minecraft.banner.square_bottom_right.black": "Black Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.blue": "Blue Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.brown": "Brown Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.cyan": "Cyan Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.gray": "Grey Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.green": "Green Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.light_blue": "Light Blue Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.light_gray": "Light Grey Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.lime": "Lime Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.magenta": "Magenta Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.orange": "Orange Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.pink": "Pink Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.purple": "Purple Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.red": "Red Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.white": "White Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.yellow": "Yellow Base Sinister Canton",
  "block.minecraft.banner.square_top_left.black": "Black Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.blue": "Blue Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.brown": "Brown Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.cyan": "Cyan Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.gray": "Grey Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.green": "Green Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.light_blue": "Light Blue Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.light_gray": "Light Grey Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.lime": "Lime Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.magenta": "Magenta Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.orange": "Orange Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.pink": "Pink Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.purple": "Purple Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.red": "Red Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.white": "White Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.yellow": "Yellow Chief Dexter Canton",
  "block.minecraft.banner.square_top_right.black": "Black Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.blue": "Blue Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.brown": "Brown Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.cyan": "Cyan Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.gray": "Grey Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.green": "Green Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.light_blue": "Light Blue Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.light_gray": "Light Grey Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.lime": "Lime Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.magenta": "Magenta Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.orange": "Orange Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.pink": "Pink Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.purple": "Purple Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.red": "Red Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.white": "White Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.yellow": "Yellow Chief Sinister Canton",
  "block.minecraft.banner.straight_cross.black": "Black Cross",
  "block.minecraft.banner.straight_cross.blue": "Blue Cross",
  "block.minecraft.banner.straight_cross.brown": "Brown Cross",
  "block.minecraft.banner.straight_cross.cyan": "Cyan Cross",
  "block.minecraft.banner.straight_cross.gray": "Grey Cross",
  "block.minecraft.banner.straight_cross.green": "Green Cross",
  "block.minecraft.banner.straight_cross.light_blue": "Light Blue Cross",
  "block.minecraft.banner.straight_cross.light_gray": "Light Grey Cross",
  "block.minecraft.banner.straight_cross.lime": "Lime Cross",
  "block.minecraft.banner.straight_cross.magenta": "Magenta Cross",
  "block.minecraft.banner.straight_cross.orange": "Orange Cross",
  "block.minecraft.banner.straight_cross.pink": "Pink Cross",
  "block.minecraft.banner.straight_cross.purple": "Purple Cross",
  "block.minecraft.banner.straight_cross.red": "Red Cross",
  "block.minecraft.banner.straight_cross.white": "White Cross",
  "block.minecraft.banner.straight_cross.yellow": "Yellow Cross",
  "block.minecraft.banner.stripe_bottom.black": "Black Base",
  "block.minecraft.banner.stripe_bottom.blue": "Blue Base",
  "block.minecraft.banner.stripe_bottom.brown": "Brown Base",
  "block.minecraft.banner.stripe_bottom.cyan": "Cyan Base",
  "block.minecraft.banner.stripe_bottom.gray": "Grey Base",
  "block.minecraft.banner.stripe_bottom.green": "Green Base",
  "block.minecraft.banner.stripe_bottom.light_blue": "Light Blue Base",
  "block.minecraft.banner.stripe_bottom.light_gray": "Light Grey Base",
  "block.minecraft.banner.stripe_bottom.lime": "Lime Base",
  "block.minecraft.banner.stripe_bottom.magenta": "Magenta Base",
  "block.minecraft.banner.stripe_bottom.orange": "Orange Base",
  "block.minecraft.banner.stripe_bottom.pink": "Pink Base",
  "block.minecraft.banner.stripe_bottom.purple": "Purple Base",
  "block.minecraft.banner.stripe_bottom.red": "Red Base",
  "block.minecraft.banner.stripe_bottom.white": "White Base",
  "block.minecraft.banner.stripe_bottom.yellow": "Yellow Base",
  "block.minecraft.banner.stripe_center.black": "Black Pale",
  "block.minecraft.banner.stripe_center.blue": "Blue Pale",
  "block.minecraft.banner.stripe_center.brown": "Brown Pale",
  "block.minecraft.banner.stripe_center.cyan": "Cyan Pale",
  "block.minecraft.banner.stripe_center.gray": "Grey Pale",
  "block.minecraft.banner.stripe_center.green": "Green Pale",
  "block.minecraft.banner.stripe_center.light_blue": "Light Blue Pale",
  "block.minecraft.banner.stripe_center.light_gray": "Light Grey Pale",
  "block.minecraft.banner.stripe_center.lime": "Lime Pale",
  "block.minecraft.banner.stripe_center.magenta": "Magenta Pale",
  "block.minecraft.banner.stripe_center.orange": "Orange Pale",
  "block.minecraft.banner.stripe_center.pink": "Pink Pale",
  "block.minecraft.banner.stripe_center.purple": "Purple Pale",
  "block.minecraft.banner.stripe_center.red": "Red Pale",
  "block.minecraft.banner.stripe_center.white": "White Pale",
  "block.minecraft.banner.stripe_center.yellow": "Yellow Pale",
  "block.minecraft.banner.stripe_downleft.black": "Black Bend Sinister",
  "block.minecraft.banner.stripe_downleft.blue": "Blue Bend Sinister",
  "block.minecraft.banner.stripe_downleft.brown": "Brown Bend Sinister",
  "block.minecraft.banner.stripe_downleft.cyan": "Cyan Bend Sinister",
  "block.minecraft.banner.stripe_downleft.gray": "Grey Bend Sinister",
  "block.minecraft.banner.stripe_downleft.green": "Green Bend Sinister",
  "block.minecraft.banner.stripe_downleft.light_blue": "Light Blue Bend Sinister",
  "block.minecraft.banner.stripe_downleft.light_gray": "Light Grey Bend Sinister",
  "block.minecraft.banner.stripe_downleft.lime": "Lime Bend Sinister",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta Bend Sinister",
  "block.minecraft.banner.stripe_downleft.orange": "Orange Bend Sinister",
  "block.minecraft.banner.stripe_downleft.pink": "Pink Bend Sinister",
  "block.minecraft.banner.stripe_downleft.purple": "Purple Bend Sinister",
  "block.minecraft.banner.stripe_downleft.red": "Red Bend Sinister",
  "block.minecraft.banner.stripe_downleft.white": "White Bend Sinister",
  "block.minecraft.banner.stripe_downleft.yellow": "Yellow Bend Sinister",
  "block.minecraft.banner.stripe_downright.black": "Black Bend",
  "block.minecraft.banner.stripe_downright.blue": "Blue Bend",
  "block.minecraft.banner.stripe_downright.brown": "Brown Bend",
  "block.minecraft.banner.stripe_downright.cyan": "Cyan Bend",
  "block.minecraft.banner.stripe_downright.gray": "Grey Bend",
  "block.minecraft.banner.stripe_downright.green": "Green Bend",
  "block.minecraft.banner.stripe_downright.light_blue": "Light Blue Bend",
  "block.minecraft.banner.stripe_downright.light_gray": "Light Grey Bend",
  "block.minecraft.banner.stripe_downright.lime": "Lime Bend",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta Bend",
  "block.minecraft.banner.stripe_downright.orange": "Orange Bend",
  "block.minecraft.banner.stripe_downright.pink": "Pink Bend",
  "block.minecraft.banner.stripe_downright.purple": "Purple Bend",
  "block.minecraft.banner.stripe_downright.red": "Red Bend",
  "block.minecraft.banner.stripe_downright.white": "White Bend",
  "block.minecraft.banner.stripe_downright.yellow": "Yellow Bend",
  "block.minecraft.banner.stripe_left.black": "Black Pale Dexter",
  "block.minecraft.banner.stripe_left.blue": "Blue Pale Dexter",
  "block.minecraft.banner.stripe_left.brown": "Brown Pale Dexter",
  "block.minecraft.banner.stripe_left.cyan": "Cyan Pale Dexter",
  "block.minecraft.banner.stripe_left.gray": "Grey Pale Dexter",
  "block.minecraft.banner.stripe_left.green": "Green Pale Dexter",
  "block.minecraft.banner.stripe_left.light_blue": "Light Blue Pale Dexter",
  "block.minecraft.banner.stripe_left.light_gray": "Light Grey Pale Dexter",
  "block.minecraft.banner.stripe_left.lime": "Lime Pale Dexter",
  "block.minecraft.banner.stripe_left.magenta": "Magenta Pale Dexter",
  "block.minecraft.banner.stripe_left.orange": "Orange Pale Dexter",
  "block.minecraft.banner.stripe_left.pink": "Pink Pale Dexter",
  "block.minecraft.banner.stripe_left.purple": "Purple Pale Dexter",
  "block.minecraft.banner.stripe_left.red": "Red Pale Dexter",
  "block.minecraft.banner.stripe_left.white": "White Pale Dexter",
  "block.minecraft.banner.stripe_left.yellow": "Yellow Pale Dexter",
  "block.minecraft.banner.stripe_middle.black": "Black Fess",
  "block.minecraft.banner.stripe_middle.blue": "Blue Fess",
  "block.minecraft.banner.stripe_middle.brown": "Brown Fess",
  "block.minecraft.banner.stripe_middle.cyan": "Cyan Fess",
  "block.minecraft.banner.stripe_middle.gray": "Grey Fess",
  "block.minecraft.banner.stripe_middle.green": "Green Fess",
  "block.minecraft.banner.stripe_middle.light_blue": "Light Blue Fess",
  "block.minecraft.banner.stripe_middle.light_gray": "Light Grey Fess",
  "block.minecraft.banner.stripe_middle.lime": "Lime Fess",
  "block.minecraft.banner.stripe_middle.magenta": "Magenta Fess",
  "block.minecraft.banner.stripe_middle.orange": "Orange Fess",
  "block.minecraft.banner.stripe_middle.pink": "Pink Fess",
  "block.minecraft.banner.stripe_middle.purple": "Purple Fess",
  "block.minecraft.banner.stripe_middle.red": "Red Fess",
  "block.minecraft.banner.stripe_middle.white": "White Fess",
  "block.minecraft.banner.stripe_middle.yellow": "Yellow Fess",
  "block.minecraft.banner.stripe_right.black": "Black Pale Sinister",
  "block.minecraft.banner.stripe_right.blue": "Blue Pale Sinister",
  "block.minecraft.banner.stripe_right.brown": "Brown Pale Sinister",
  "block.minecraft.banner.stripe_right.cyan": "Cyan Pale Sinister",
  "block.minecraft.banner.stripe_right.gray": "Grey Pale Sinister",
  "block.minecraft.banner.stripe_right.green": "Green Pale Sinister",
  "block.minecraft.banner.stripe_right.light_blue": "Light Blue Pale Sinister",
  "block.minecraft.banner.stripe_right.light_gray": "Light Grey Pale Sinister",
  "block.minecraft.banner.stripe_right.lime": "Lime Pale Sinister",
  "block.minecraft.banner.stripe_right.magenta": "Magenta Pale Sinister",
  "block.minecraft.banner.stripe_right.orange": "Orange Pale Sinister",
  "block.minecraft.banner.stripe_right.pink": "Pink Pale Sinister",
  "block.minecraft.banner.stripe_right.purple": "Purple Pale Sinister",
  "block.minecraft.banner.stripe_right.red": "Red Pale Sinister",
  "block.minecraft.banner.stripe_right.white": "White Pale Sinister",
  "block.minecraft.banner.stripe_right.yellow": "Yellow Pale Sinister",
  "block.minecraft.banner.stripe_top.black": "Black Chief",
  "block.minecraft.banner.stripe_top.blue": "Blue Chief",
  "block.minecraft.banner.stripe_top.brown": "Brown Chief",
  "block.minecraft.banner.stripe_top.cyan": "Cyan Chief",
  "block.minecraft.banner.stripe_top.gray": "Grey Chief",
  "block.minecraft.banner.stripe_top.green": "Green Chief",
  "block.minecraft.banner.stripe_top.light_blue": "Light Blue Chief",
  "block.minecraft.banner.stripe_top.light_gray": "Light Grey Chief",
  "block.minecraft.banner.stripe_top.lime": "Lime Chief",
  "block.minecraft.banner.stripe_top.magenta": "Magenta Chief",
  "block.minecraft.banner.stripe_top.orange": "Orange Chief",
  "block.minecraft.banner.stripe_top.pink": "Pink Chief",
  "block.minecraft.banner.stripe_top.purple": "Purple Chief",
  "block.minecraft.banner.stripe_top.red": "Red Chief",
  "block.minecraft.banner.stripe_top.white": "White Chief",
  "block.minecraft.banner.stripe_top.yellow": "Yellow Chief",
  "block.minecraft.banner.triangle_bottom.black": "Black Chevron",
  "block.minecraft.banner.triangle_bottom.blue": "Blue Chevron",
  "block.minecraft.banner.triangle_bottom.brown": "Brown Chevron",
  "block.minecraft.banner.triangle_bottom.cyan": "Cyan Chevron",
  "block.minecraft.banner.triangle_bottom.gray": "Grey Chevron",
  "block.minecraft.banner.triangle_bottom.green": "Green Chevron",
  "block.minecraft.banner.triangle_bottom.light_blue": "Light Blue Chevron",
  "block.minecraft.banner.triangle_bottom.light_gray": "Light Grey Chevron",
  "block.minecraft.banner.triangle_bottom.lime": "Lime Chevron",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenta Chevron",
  "block.minecraft.banner.triangle_bottom.orange": "Orange Chevron",
  "block.minecraft.banner.triangle_bottom.pink": "Pink Chevron",
  "block.minecraft.banner.triangle_bottom.purple": "Purple Chevron",
  "block.minecraft.banner.triangle_bottom.red": "Red Chevron",
  "block.minecraft.banner.triangle_bottom.white": "White Chevron",
  "block.minecraft.banner.triangle_bottom.yellow": "Yellow Chevron",
  "block.minecraft.banner.triangle_top.black": "Black Inverted Chevron",
  "block.minecraft.banner.triangle_top.blue": "Blue Inverted Chevron",
  "block.minecraft.banner.triangle_top.brown": "Brown Inverted Chevron",
  "block.minecraft.banner.triangle_top.cyan": "Cyan Inverted Chevron",
  "block.minecraft.banner.triangle_top.gray": "Grey Inverted Chevron",
  "block.minecraft.banner.triangle_top.green": "Green Inverted Chevron",
  "block.minecraft.banner.triangle_top.light_blue": "Light Blue Inverted Chevron",
  "block.minecraft.banner.triangle_top.light_gray": "Light Grey Inverted Chevron",
  "block.minecraft.banner.triangle_top.lime": "Lime Inverted Chevron",
  "block.minecraft.banner.triangle_top.magenta": "Magenta Inverted Chevron",
  "block.minecraft.banner.triangle_top.orange": "Orange Inverted Chevron",
  "block.minecraft.banner.triangle_top.pink": "Pink Inverted Chevron",
  "block.minecraft.banner.triangle_top.purple": "Purple Inverted Chevron",
  "block.minecraft.banner.triangle_top.red": "Red Inverted Chevron",
  "block.minecraft.banner.triangle_top.white": "White Inverted Chevron",
  "block.minecraft.banner.triangle_top.yellow": "Yellow Inverted Chevron",
  "block.minecraft.banner.triangles_bottom.black": "Black Base Indented",
  "block.minecraft.banner.triangles_bottom.blue": "Blue Base Indented",
  "block.minecraft.banner.triangles_bottom.brown": "Brown Base Indented",
  "block.minecraft.banner.triangles_bottom.cyan": "Cyan Base Indented",
  "block.minecraft.banner.triangles_bottom.gray": "Grey Base Indented",
  "block.minecraft.banner.triangles_bottom.green": "Green Base Indented",
  "block.minecraft.banner.triangles_bottom.light_blue": "Light Blue Base Indented",
  "block.minecraft.banner.triangles_bottom.light_gray": "Light Grey Base Indented",
  "block.minecraft.banner.triangles_bottom.lime": "Lime Base Indented",
  "block.minecraft.banner.triangles_bottom.magenta": "Magenta Base Indented",
  "block.minecraft.banner.triangles_bottom.orange": "Orange Base Indented",
  "block.minecraft.banner.triangles_bottom.pink": "Pink Base Indented",
  "block.minecraft.banner.triangles_bottom.purple": "Purple Base Indented",
  "block.minecraft.banner.triangles_bottom.red": "Red Base Indented",
  "block.minecraft.banner.triangles_bottom.white": "White Base Indented",
  "block.minecraft.banner.triangles_bottom.yellow": "Yellow Base Indented",
  "block.minecraft.banner.triangles_top.black": "Black Chief Indented",
  "block.minecraft.banner.triangles_top.blue": "Blue Chief Indented",
  "block.minecraft.banner.triangles_top.brown": "Brown Chief Indented",
  "block.minecraft.banner.triangles_top.cyan": "Cyan Chief Indented",
  "block.minecraft.banner.triangles_top.gray": "Grey Chief Indented",
  "block.minecraft.banner.triangles_top.green": "Green Chief Indented",
  "block.minecraft.banner.triangles_top.light_blue": "Light Blue Chief Indented",
  "block.minecraft.banner.triangles_top.light_gray": "Light Grey Chief Indented",
  "block.minecraft.banner.triangles_top.lime": "Lime Chief Indented",
  "block.minecraft.banner.triangles_top.magenta": "Magenta Chief Indented",
  "block.minecraft.banner.triangles_top.orange": "Orange Chief Indented",
  "block.minecraft.banner.triangles_top.pink": "Pink Chief Indented",
  "block.minecraft.banner.triangles_top.purple": "Purple Chief Indented",
  "block.minecraft.banner.triangles_top.red": "Red Chief Indented",
  "block.minecraft.banner.triangles_top.white": "White Chief Indented",
  "block.minecraft.banner.triangles_top.yellow": "Yellow Chief Indented",
  "block.minecraft.barrel": "Barrel",
  "block.minecraft.barrier": "Barrier",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Beacon",
  "block.minecraft.beacon.primary": "Primary Power",
  "block.minecraft.beacon.secondary": "Secondary Power",
  "block.minecraft.bed.no_sleep": "You can sleep only at night or during thunderstorms",
  "block.minecraft.bed.not_safe": "You may not rest now; there are monsters nearby",
  "block.minecraft.bed.obstructed": "This Bed is obstructed",
  "block.minecraft.bed.occupied": "This Bed is occupied",
  "block.minecraft.bed.too_far_away": "You may not rest now; the Bed is too far away",
  "block.minecraft.bedrock": "Bedrock",
  "block.minecraft.bee_nest": "Bee Nest",
  "block.minecraft.beehive": "Beehive",
  "block.minecraft.beetroots": "Beetroots",
  "block.minecraft.bell": "Bell",
  "block.minecraft.big_dripleaf": "Big Dripleaf",
  "block.minecraft.big_dripleaf_stem": "Big Dripleaf Stem",
  "block.minecraft.birch_button": "Birch Button",
  "block.minecraft.birch_door": "Birch Door",
  "block.minecraft.birch_fence": "Birch Fence",
  "block.minecraft.birch_fence_gate": "Birch Fence Gate",
  "block.minecraft.birch_hanging_sign": "Birch Hanging Sign",
  "block.minecraft.birch_leaves": "Birch Leaves",
  "block.minecraft.birch_log": "Birch Log",
  "block.minecraft.birch_planks": "Birch Planks",
  "block.minecraft.birch_pressure_plate": "Birch Pressure Plate",
  "block.minecraft.birch_sapling": "Birch Sapling",
  "block.minecraft.birch_shelf": "Birch Shelf",
  "block.minecraft.birch_sign": "Birch Sign",
  "block.minecraft.birch_slab": "Birch Slab",
  "block.minecraft.birch_stairs": "Birch Stairs",
  "block.minecraft.birch_trapdoor": "Birch Trapdoor",
  "block.minecraft.birch_wall_hanging_sign": "Birch Wall Hanging Sign",
  "block.minecraft.birch_wall_sign": "Birch Wall Sign",
  "block.minecraft.birch_wood": "Birch Wood",
  "block.minecraft.black_banner": "Black Banner",
  "block.minecraft.black_bed": "Black Bed",
  "block.minecraft.black_candle": "Black Candle",
  "block.minecraft.black_candle_cake": "Cake with Black Candle",
  "block.minecraft.black_carpet": "Black Carpet",
  "block.minecraft.black_concrete": "Black Concrete",
  "block.minecraft.black_concrete_powder": "Black Concrete Powder",
  "block.minecraft.black_glazed_terracotta": "Black Glazed Terracotta",
  "block.minecraft.black_shulker_box": "Black Shulker Box",
  "block.minecraft.black_stained_glass": "Black Stained Glass",
  "block.minecraft.black_stained_glass_pane": "Black Stained Glass Pane",
  "block.minecraft.black_terracotta": "Black Terracotta",
  "block.minecraft.black_wool": "Black Wool",
  "block.minecraft.blackstone": "Blackstone",
  "block.minecraft.blackstone_slab": "Blackstone Slab",
  "block.minecraft.blackstone_stairs": "Blackstone Stairs",
  "block.minecraft.blackstone_wall": "Blackstone Wall",
  "block.minecraft.blast_furnace": "Blast Furnace",
  "block.minecraft.blue_banner": "Blue Banner",
  "block.minecraft.blue_bed": "Blue Bed",
  "block.minecraft.blue_candle": "Blue Candle",
  "block.minecraft.blue_candle_cake": "Cake with Blue Candle",
  "block.minecraft.blue_carpet": "Blue Carpet",
  "block.minecraft.blue_concrete": "Blue Concrete",
  "block.minecraft.blue_concrete_powder": "Blue Concrete Powder",
  "block.minecraft.blue_glazed_terracotta": "Blue Glazed Terracotta",
  "block.minecraft.blue_ice": "Blue Ice",
  "block.minecraft.blue_orchid": "Blue Orchid",
  "block.minecraft.blue_shulker_box": "Blue Shulker Box",
  "block.minecraft.blue_stained_glass": "Blue Stained Glass",
  "block.minecraft.blue_stained_glass_pane": "Blue Stained Glass Pane",
  "block.minecraft.blue_terracotta": "Blue Terracotta",
  "block.minecraft.blue_wool": "Blue Wool",
  "block.minecraft.bone_block": "Bone Block",
  "block.minecraft.bookshelf": "Bookshelf",
  "block.minecraft.brain_coral": "Brain Coral",
  "block.minecraft.brain_coral_block": "Brain Coral Block",
  "block.minecraft.brain_coral_fan": "Brain Coral Fan",
  "block.minecraft.brain_coral_wall_fan": "Brain Coral Wall Fan",
  "block.minecraft.brewing_stand": "Brewing Stand",
  "block.minecraft.brick_slab": "Brick Slab",
  "block.minecraft.brick_stairs": "Brick Stairs",
  "block.minecraft.brick_wall": "Brick Wall",
  "block.minecraft.bricks": "Bricks",
  "block.minecraft.brown_banner": "Brown Banner",
  "block.minecraft.brown_bed": "Brown Bed",
  "block.minecraft.brown_candle": "Brown Candle",
  "block.minecraft.brown_candle_cake": "Cake with Brown Candle",
  "block.minecraft.brown_carpet": "Brown Carpet",
  "block.minecraft.brown_concrete": "Brown Concrete",
  "block.minecraft.brown_concrete_powder": "Brown Concrete Powder",
  "block.minecraft.brown_glazed_terracotta": "Brown Glazed Terracotta",
  "block.minecraft.brown_mushroom": "Brown Mushroom",
  "block.minecraft.brown_mushroom_block": "Brown Mushroom Block",
  "block.minecraft.brown_shulker_box": "Brown Shulker Box",
  "block.minecraft.brown_stained_glass": "Brown Stained Glass",
  "block.minecraft.brown_stained_glass_pane": "Brown Stained Glass Pane",
  "block.minecraft.brown_terracotta": "Brown Terracotta",
  "block.minecraft.brown_wool": "Brown Wool",
  "block.minecraft.bubble_column": "Bubble Column",
  "block.minecraft.bubble_coral": "Bubble Coral",
  "block.minecraft.bubble_coral_block": "Bubble Coral Block",
  "block.minecraft.bubble_coral_fan": "Bubble Coral Fan",
  "block.minecraft.bubble_coral_wall_fan": "Bubble Coral Wall Fan",
  "block.minecraft.budding_amethyst": "Budding Amethyst",
  "block.minecraft.bush": "Bush",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Cactus Flower",
  "block.minecraft.cake": "Cake",
  "block.minecraft.calcite": "Calcite",
  "block.minecraft.calibrated_sculk_sensor": "Calibrated Sculk Sensor",
  "block.minecraft.campfire": "Campfire",
  "block.minecraft.candle": "Candle",
  "block.minecraft.candle_cake": "Cake with Candle",
  "block.minecraft.carrots": "Carrots",
  "block.minecraft.cartography_table": "Cartography Table",
  "block.minecraft.carved_pumpkin": "Carved Pumpkin",
  "block.minecraft.cauldron": "Cauldron",
  "block.minecraft.cave_air": "Cave Air",
  "block.minecraft.cave_vines": "Cave Vines",
  "block.minecraft.cave_vines_plant": "Cave Vines Plant",
  "block.minecraft.chain": "Chain",
  "block.minecraft.chain_command_block": "Chain Command Block",
  "block.minecraft.cherry_button": "Cherry Button",
  "block.minecraft.cherry_door": "Cherry Door",
  "block.minecraft.cherry_fence": "Cherry Fence",
  "block.minecraft.cherry_fence_gate": "Cherry Fence Gate",
  "block.minecraft.cherry_hanging_sign": "Cherry Hanging Sign",
  "block.minecraft.cherry_leaves": "Cherry Leaves",
  "block.minecraft.cherry_log": "Cherry Log",
  "block.minecraft.cherry_planks": "Cherry Planks",
  "block.minecraft.cherry_pressure_plate": "Cherry Pressure Plate",
  "block.minecraft.cherry_sapling": "Cherry Sapling",
  "block.minecraft.cherry_shelf": "Cherry Shelf",
  "block.minecraft.cherry_sign": "Cherry Sign",
  "block.minecraft.cherry_slab": "Cherry Slab",
  "block.minecraft.cherry_stairs": "Cherry Stairs",
  "block.minecraft.cherry_trapdoor": "Cherry Trapdoor",
  "block.minecraft.cherry_wall_hanging_sign": "Cherry Wall Hanging Sign",
  "block.minecraft.cherry_wall_sign": "Cherry Wall Sign",
  "block.minecraft.cherry_wood": "Cherry Wood",
  "block.minecraft.chest": "Chest",
  "block.minecraft.chipped_anvil": "Chipped Anvil",
  "block.minecraft.chiseled_bookshelf": "Chiselled Bookshelf",
  "block.minecraft.chiseled_copper": "Chiselled Copper",
  "block.minecraft.chiseled_deepslate": "Chiselled Deepslate",
  "block.minecraft.chiseled_nether_bricks": "Chiselled Nether Bricks",
  "block.minecraft.chiseled_polished_blackstone": "Chiselled Polished Blackstone",
  "block.minecraft.chiseled_quartz_block": "Chiselled Quartz Block",
  "block.minecraft.chiseled_red_sandstone": "Chiselled Red Sandstone",
  "block.minecraft.chiseled_resin_bricks": "Chiselled Resin Bricks",
  "block.minecraft.chiseled_sandstone": "Chiselled Sandstone",
  "block.minecraft.chiseled_stone_bricks": "Chiselled Stone Bricks",
  "block.minecraft.chiseled_tuff": "Chiselled Tuff",
  "block.minecraft.chiseled_tuff_bricks": "Chiselled Tuff Bricks",
  "block.minecraft.chorus_flower": "Chorus Flower",
  "block.minecraft.chorus_plant": "Chorus Plant",
  "block.minecraft.clay": "Clay",
  "block.minecraft.closed_eyeblossom": "Closed Eyeblossom",
  "block.minecraft.coal_block": "Block of Coal",
  "block.minecraft.coal_ore": "Coal Ore",
  "block.minecraft.coarse_dirt": "Coarse Dirt",
  "block.minecraft.cobbled_deepslate": "Cobbled Deepslate",
  "block.minecraft.cobbled_deepslate_slab": "Cobbled Deepslate Slab",
  "block.minecraft.cobbled_deepslate_stairs": "Cobbled Deepslate Stairs",
  "block.minecraft.cobbled_deepslate_wall": "Cobbled Deepslate Wall",
  "block.minecraft.cobblestone": "Cobblestone",
  "block.minecraft.cobblestone_slab": "Cobblestone Slab",
  "block.minecraft.cobblestone_stairs": "Cobblestone Stairs",
  "block.minecraft.cobblestone_wall": "Cobblestone Wall",
  "block.minecraft.cobweb": "Cobweb",
  "block.minecraft.cocoa": "Cocoa",
  "block.minecraft.command_block": "Command Block",
  "block.minecraft.comparator": "Redstone Comparator",
  "block.minecraft.composter": "Composter",
  "block.minecraft.conduit": "Conduit",
  "block.minecraft.copper_bars": "Copper Bars",
  "block.minecraft.copper_block": "Block of Copper",
  "block.minecraft.copper_bulb": "Copper Bulb",
  "block.minecraft.copper_chain": "Copper Chain",
  "block.minecraft.copper_chest": "Copper Chest",
  "block.minecraft.copper_door": "Copper Door",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "Copper Grate",
  "block.minecraft.copper_lantern": "Copper Lantern",
  "block.minecraft.copper_ore": "Copper Ore",
  "block.minecraft.copper_torch": "Copper Torch",
  "block.minecraft.copper_trapdoor": "Copper Trapdoor",
  "block.minecraft.copper_wall_torch": "Copper Wall Torch",
  "block.minecraft.cornflower": "Cornflower",
  "block.minecraft.cracked_deepslate_bricks": "Cracked Deepslate Bricks",
  "block.minecraft.cracked_deepslate_tiles": "Cracked Deepslate Tiles",
  "block.minecraft.cracked_nether_bricks": "Cracked Nether Bricks",
  "block.minecraft.cracked_polished_blackstone_bricks": "Cracked Polished Blackstone Bricks",
  "block.minecraft.cracked_stone_bricks": "Cracked Stone Bricks",
  "block.minecraft.crafter": "Crafter",
  "block.minecraft.crafting_table": "Crafting Table",
  "block.minecraft.creaking_heart": "Creaking Heart",
  "block.minecraft.creeper_head": "Creeper Head",
  "block.minecraft.creeper_wall_head": "Creeper Wall Head",
  "block.minecraft.crimson_button": "Crimson Button",
  "block.minecraft.crimson_door": "Crimson Door",
  "block.minecraft.crimson_fence": "Crimson Fence",
  "block.minecraft.crimson_fence_gate": "Crimson Fence Gate",
  "block.minecraft.crimson_fungus": "Crimson Fungus",
  "block.minecraft.crimson_hanging_sign": "Crimson Hanging Sign",
  "block.minecraft.crimson_hyphae": "Crimson Hyphae",
  "block.minecraft.crimson_nylium": "Crimson Nylium",
  "block.minecraft.crimson_planks": "Crimson Planks",
  "block.minecraft.crimson_pressure_plate": "Crimson Pressure Plate",
  "block.minecraft.crimson_roots": "Crimson Roots",
  "block.minecraft.crimson_shelf": "Crimson Shelf",
  "block.minecraft.crimson_sign": "Crimson Sign",
  "block.minecraft.crimson_slab": "Crimson Slab",
  "block.minecraft.crimson_stairs": "Crimson Stairs",
  "block.minecraft.crimson_stem": "Crimson Stem",
  "block.minecraft.crimson_trapdoor": "Crimson Trapdoor",
  "block.minecraft.crimson_wall_hanging_sign": "Crimson Wall Hanging Sign",
  "block.minecraft.crimson_wall_sign": "Crimson Wall Sign",
  "block.minecraft.crying_obsidian": "Crying Obsidian",
  "block.minecraft.cut_copper": "Cut Copper",
  "block.minecraft.cut_copper_slab": "Cut Copper Slab",
  "block.minecraft.cut_copper_stairs": "Cut Copper Stairs",
  "block.minecraft.cut_red_sandstone": "Cut Red Sandstone",
  "block.minecraft.cut_red_sandstone_slab": "Cut Red Sandstone Slab",
  "block.minecraft.cut_sandstone": "Cut Sandstone",
  "block.minecraft.cut_sandstone_slab": "Cut Sandstone Slab",
  "block.minecraft.cyan_banner": "Cyan Banner",
  "block.minecraft.cyan_bed": "Cyan Bed",
  "block.minecraft.cyan_candle": "Cyan Candle",
  "block.minecraft.cyan_candle_cake": "Cake with Cyan Candle",
  "block.minecraft.cyan_carpet": "Cyan Carpet",
  "block.minecraft.cyan_concrete": "Cyan Concrete",
  "block.minecraft.cyan_concrete_powder": "Cyan Concrete Powder",
  "block.minecraft.cyan_glazed_terracotta": "Cyan Glazed Terracotta",
  "block.minecraft.cyan_shulker_box": "Cyan Shulker Box",
  "block.minecraft.cyan_stained_glass": "Cyan Stained Glass",
  "block.minecraft.cyan_stained_glass_pane": "Cyan Stained Glass Pane",
  "block.minecraft.cyan_terracotta": "Cyan Terracotta",
  "block.minecraft.cyan_wool": "Cyan Wool",
  "block.minecraft.damaged_anvil": "Damaged Anvil",
  "block.minecraft.dandelion": "Dandelion",
  "block.minecraft.dark_oak_button": "Dark Oak Button",
  "block.minecraft.dark_oak_door": "Dark Oak Door",
  "block.minecraft.dark_oak_fence": "Dark Oak Fence",
  "block.minecraft.dark_oak_fence_gate": "Dark Oak Fence Gate",
  "block.minecraft.dark_oak_hanging_sign": "Dark Oak Hanging Sign",
  "block.minecraft.dark_oak_leaves": "Dark Oak Leaves",
  "block.minecraft.dark_oak_log": "Dark Oak Log",
  "block.minecraft.dark_oak_planks": "Dark Oak Planks",
  "block.minecraft.dark_oak_pressure_plate": "Dark Oak Pressure Plate",
  "block.minecraft.dark_oak_sapling": "Dark Oak Sapling",
  "block.minecraft.dark_oak_shelf": "Dark Oak Shelf",
  "block.minecraft.dark_oak_sign": "Dark Oak Sign",
  "block.minecraft.dark_oak_slab": "Dark Oak Slab",
  "block.minecraft.dark_oak_stairs": "Dark Oak Stairs",
  "block.minecraft.dark_oak_trapdoor": "Dark Oak Trapdoor",
  "block.minecraft.dark_oak_wall_hanging_sign": "Dark Oak Wall Hanging Sign",
  "block.minecraft.dark_oak_wall_sign": "Dark Oak Wall Sign",
  "block.minecraft.dark_oak_wood": "Dark Oak Wood",
  "block.minecraft.dark_prismarine": "Dark Prismarine",
  "block.minecraft.dark_prismarine_slab": "Dark Prismarine Slab",
  "block.minecraft.dark_prismarine_stairs": "Dark Prismarine Stairs",
  "block.minecraft.daylight_detector": "Daylight Detector",
  "block.minecraft.dead_brain_coral": "Dead Brain Coral",
  "block.minecraft.dead_brain_coral_block": "Dead Brain Coral Block",
  "block.minecraft.dead_brain_coral_fan": "Dead Brain Coral Fan",
  "block.minecraft.dead_brain_coral_wall_fan": "Dead Brain Coral Wall Fan",
  "block.minecraft.dead_bubble_coral": "Dead Bubble Coral",
  "block.minecraft.dead_bubble_coral_block": "Dead Bubble Coral Block",
  "block.minecraft.dead_bubble_coral_fan": "Dead Bubble Coral Fan",
  "block.minecraft.dead_bubble_coral_wall_fan": "Dead Bubble Coral Wall Fan",
  "block.minecraft.dead_bush": "Dead Bush",
  "block.minecraft.dead_fire_coral": "Dead Fire Coral",
  "block.minecraft.dead_fire_coral_block": "Dead Fire Coral Block",
  "block.minecraft.dead_fire_coral_fan": "Dead Fire Coral Fan",
  "block.minecraft.dead_fire_coral_wall_fan": "Dead Fire Coral Wall Fan",
  "block.minecraft.dead_horn_coral": "Dead Horn Coral",
  "block.minecraft.dead_horn_coral_block": "Dead Horn Coral Block",
  "block.minecraft.dead_horn_coral_fan": "Dead Horn Coral Fan",
  "block.minecraft.dead_horn_coral_wall_fan": "Dead Horn Coral Wall Fan",
  "block.minecraft.dead_tube_coral": "Dead Tube Coral",
  "block.minecraft.dead_tube_coral_block": "Dead Tube Coral Block",
  "block.minecraft.dead_tube_coral_fan": "Dead Tube Coral Fan",
  "block.minecraft.dead_tube_coral_wall_fan": "Dead Tube Coral Wall Fan",
  "block.minecraft.decorated_pot": "Decorated Pot",
  "block.minecraft.deepslate": "Deepslate",
  "block.minecraft.deepslate_brick_slab": "Deepslate Brick Slab",
  "block.minecraft.deepslate_brick_stairs": "Deepslate Brick Stairs",
  "block.minecraft.deepslate_brick_wall": "Deepslate Brick Wall",
  "block.minecraft.deepslate_bricks": "Deepslate Bricks",
  "block.minecraft.deepslate_coal_ore": "Deepslate Coal Ore",
  "block.minecraft.deepslate_copper_ore": "Deepslate Copper Ore",
  "block.minecraft.deepslate_diamond_ore": "Deepslate Diamond Ore",
  "block.minecraft.deepslate_emerald_ore": "Deepslate Emerald Ore",
  "block.minecraft.deepslate_gold_ore": "Deepslate Gold Ore",
  "block.minecraft.deepslate_iron_ore": "Deepslate Iron Ore",
  "block.minecraft.deepslate_lapis_ore": "Deepslate Lapis Lazuli Ore",
  "block.minecraft.deepslate_redstone_ore": "Deepslate Redstone Ore",
  "block.minecraft.deepslate_tile_slab": "Deepslate Tile Slab",
  "block.minecraft.deepslate_tile_stairs": "Deepslate Tile Stairs",
  "block.minecraft.deepslate_tile_wall": "Deepslate Tile Wall",
  "block.minecraft.deepslate_tiles": "Deepslate Tiles",
  "block.minecraft.detector_rail": "Detector Rail",
  "block.minecraft.diamond_block": "Block of Diamond",
  "block.minecraft.diamond_ore": "Diamond Ore",
  "block.minecraft.diorite": "Diorite",
  "block.minecraft.diorite_slab": "Diorite Slab",
  "block.minecraft.diorite_stairs": "Diorite Stairs",
  "block.minecraft.diorite_wall": "Diorite Wall",
  "block.minecraft.dirt": "Dirt",
  "block.minecraft.dirt_path": "Dirt Path",
  "block.minecraft.dispenser": "Dispenser",
  "block.minecraft.dragon_egg": "Dragon Egg",
  "block.minecraft.dragon_head": "Dragon Head",
  "block.minecraft.dragon_wall_head": "Dragon Wall Head",
  "block.minecraft.dried_ghast": "Dried Ghast",
  "block.minecraft.dried_kelp_block": "Dried Kelp Block",
  "block.minecraft.dripstone_block": "Dripstone Block",
  "block.minecraft.dropper": "Dropper",
  "block.minecraft.emerald_block": "Block of Emerald",
  "block.minecraft.emerald_ore": "Emerald Ore",
  "block.minecraft.enchanting_table": "Enchanting Table",
  "block.minecraft.end_gateway": "End Gateway",
  "block.minecraft.end_portal": "End Portal",
  "block.minecraft.end_portal_frame": "End Portal Frame",
  "block.minecraft.end_rod": "End Rod",
  "block.minecraft.end_stone": "End Stone",
  "block.minecraft.end_stone_brick_slab": "End Stone Brick Slab",
  "block.minecraft.end_stone_brick_stairs": "End Stone Brick Stairs",
  "block.minecraft.end_stone_brick_wall": "End Stone Brick Wall",
  "block.minecraft.end_stone_bricks": "End Stone Bricks",
  "block.minecraft.ender_chest": "Ender Chest",
  "block.minecraft.exposed_chiseled_copper": "Exposed Chiselled Copper",
  "block.minecraft.exposed_copper": "Exposed Copper",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Exposed Copper Bulb",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Exposed Copper Door",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "Exposed Copper Grate",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Exposed Copper Trapdoor",
  "block.minecraft.exposed_cut_copper": "Exposed Cut Copper",
  "block.minecraft.exposed_cut_copper_slab": "Exposed Cut Copper Slab",
  "block.minecraft.exposed_cut_copper_stairs": "Exposed Cut Copper Stairs",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "Farmland",
  "block.minecraft.fern": "Fern",
  "block.minecraft.fire": "Fire",
  "block.minecraft.fire_coral": "Fire Coral",
  "block.minecraft.fire_coral_block": "Fire Coral Block",
  "block.minecraft.fire_coral_fan": "Fire Coral Fan",
  "block.minecraft.fire_coral_wall_fan": "Fire Coral Wall Fan",
  "block.minecraft.firefly_bush": "Firefly Bush",
  "block.minecraft.fletching_table": "Fletching Table",
  "block.minecraft.flower_pot": "Flower Pot",
  "block.minecraft.flowering_azalea": "Flowering Azalea",
  "block.minecraft.flowering_azalea_leaves": "Flowering Azalea Leaves",
  "block.minecraft.frogspawn": "Frogspawn",
  "block.minecraft.frosted_ice": "Frosted Ice",
  "block.minecraft.furnace": "Furnace",
  "block.minecraft.gilded_blackstone": "Gilded Blackstone",
  "block.minecraft.glass": "Glass",
  "block.minecraft.glass_pane": "Glass Pane",
  "block.minecraft.glow_lichen": "Glow Lichen",
  "block.minecraft.glowstone": "Glowstone",
  "block.minecraft.gold_block": "Block of Gold",
  "block.minecraft.gold_ore": "Gold Ore",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Granite",
  "block.minecraft.granite_slab": "Granite Slab",
  "block.minecraft.granite_stairs": "Granite Stairs",
  "block.minecraft.granite_wall": "Granite Wall",
  "block.minecraft.grass": "Grass",
  "block.minecraft.grass_block": "Grass Block",
  "block.minecraft.gravel": "Gravel",
  "block.minecraft.gray_banner": "Grey Banner",
  "block.minecraft.gray_bed": "Grey Bed",
  "block.minecraft.gray_candle": "Grey Candle",
  "block.minecraft.gray_candle_cake": "Cake with Grey Candle",
  "block.minecraft.gray_carpet": "Grey Carpet",
  "block.minecraft.gray_concrete": "Grey Concrete",
  "block.minecraft.gray_concrete_powder": "Grey Concrete Powder",
  "block.minecraft.gray_glazed_terracotta": "Grey Glazed Terracotta",
  "block.minecraft.gray_shulker_box": "Grey Shulker Box",
  "block.minecraft.gray_stained_glass": "Grey Stained Glass",
  "block.minecraft.gray_stained_glass_pane": "Grey Stained Glass Pane",
  "block.minecraft.gray_terracotta": "Grey Terracotta",
  "block.minecraft.gray_wool": "Grey Wool",
  "block.minecraft.green_banner": "Green Banner",
  "block.minecraft.green_bed": "Green Bed",
  "block.minecraft.green_candle": "Green Candle",
  "block.minecraft.green_candle_cake": "Cake with Green Candle",
  "block.minecraft.green_carpet": "Green Carpet",
  "block.minecraft.green_concrete": "Green Concrete",
  "block.minecraft.green_concrete_powder": "Green Concrete Powder",
  "block.minecraft.green_glazed_terracotta": "Green Glazed Terracotta",
  "block.minecraft.green_shulker_box": "Green Shulker Box",
  "block.minecraft.green_stained_glass": "Green Stained Glass",
  "block.minecraft.green_stained_glass_pane": "Green Stained Glass Pane",
  "block.minecraft.green_terracotta": "Green Terracotta",
  "block.minecraft.green_wool": "Green Wool",
  "block.minecraft.grindstone": "Grindstone",
  "block.minecraft.hanging_roots": "Hanging Roots",
  "block.minecraft.hay_block": "Hay Bale",
  "block.minecraft.heavy_core": "Heavy Core",
  "block.minecraft.heavy_weighted_pressure_plate": "Heavy Weighted Pressure Plate",
  "block.minecraft.honey_block": "Honey Block",
  "block.minecraft.honeycomb_block": "Honeycomb Block",
  "block.minecraft.hopper": "Hopper",
  "block.minecraft.horn_coral": "Horn Coral",
  "block.minecraft.horn_coral_block": "Horn Coral Block",
  "block.minecraft.horn_coral_fan": "Horn Coral Fan",
  "block.minecraft.horn_coral_wall_fan": "Horn Coral Wall Fan",
  "block.minecraft.ice": "Ice",
  "block.minecraft.infested_chiseled_stone_bricks": "Infested Chiselled Stone Bricks",
  "block.minecraft.infested_cobblestone": "Infested Cobblestone",
  "block.minecraft.infested_cracked_stone_bricks": "Infested Cracked Stone Bricks",
  "block.minecraft.infested_deepslate": "Infested Deepslate",
  "block.minecraft.infested_mossy_stone_bricks": "Infested Mossy Stone Bricks",
  "block.minecraft.infested_stone": "Infested Stone",
  "block.minecraft.infested_stone_bricks": "Infested Stone Bricks",
  "block.minecraft.iron_bars": "Iron Bars",
  "block.minecraft.iron_block": "Block of Iron",
  "block.minecraft.iron_chain": "Iron Chain",
  "block.minecraft.iron_door": "Iron Door",
  "block.minecraft.iron_ore": "Iron Ore",
  "block.minecraft.iron_trapdoor": "Iron Trapdoor",
  "block.minecraft.jack_o_lantern": "Jack o'Lantern",
  "block.minecraft.jigsaw": "Jigsaw Block",
  "block.minecraft.jukebox": "Jukebox",
  "block.minecraft.jungle_button": "Jungle Button",
  "block.minecraft.jungle_door": "Jungle Door",
  "block.minecraft.jungle_fence": "Jungle Fence",
  "block.minecraft.jungle_fence_gate": "Jungle Fence Gate",
  "block.minecraft.jungle_hanging_sign": "Jungle Hanging Sign",
  "block.minecraft.jungle_leaves": "Jungle Leaves",
  "block.minecraft.jungle_log": "Jungle Log",
  "block.minecraft.jungle_planks": "Jungle Planks",
  "block.minecraft.jungle_pressure_plate": "Jungle Pressure Plate",
  "block.minecraft.jungle_sapling": "Jungle Sapling",
  "block.minecraft.jungle_shelf": "Jungle Shelf",
  "block.minecraft.jungle_sign": "Jungle Sign",
  "block.minecraft.jungle_slab": "Jungle Slab",
  "block.minecraft.jungle_stairs": "Jungle Stairs",
  "block.minecraft.jungle_trapdoor": "Jungle Trapdoor",
  "block.minecraft.jungle_wall_hanging_sign": "Jungle Wall Hanging Sign",
  "block.minecraft.jungle_wall_sign": "Jungle Wall Sign",
  "block.minecraft.jungle_wood": "Jungle Wood",
  "block.minecraft.kelp": "Kelp",
  "block.minecraft.kelp_plant": "Kelp Plant",
  "block.minecraft.ladder": "Ladder",
  "block.minecraft.lantern": "Lantern",
  "block.minecraft.lapis_block": "Block of Lapis Lazuli",
  "block.minecraft.lapis_ore": "Lapis Lazuli Ore",
  "block.minecraft.large_amethyst_bud": "Large Amethyst Bud",
  "block.minecraft.large_fern": "Large Fern",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lava Cauldron",
  "block.minecraft.leaf_litter": "Leaf Litter",
  "block.minecraft.lectern": "Lectern",
  "block.minecraft.lever": "Lever",
  "block.minecraft.light": "Light",
  "block.minecraft.light_blue_banner": "Light Blue Banner",
  "block.minecraft.light_blue_bed": "Light Blue Bed",
  "block.minecraft.light_blue_candle": "Light Blue Candle",
  "block.minecraft.light_blue_candle_cake": "Cake with Light Blue Candle",
  "block.minecraft.light_blue_carpet": "Light Blue Carpet",
  "block.minecraft.light_blue_concrete": "Light Blue Concrete",
  "block.minecraft.light_blue_concrete_powder": "Light Blue Concrete Powder",
  "block.minecraft.light_blue_glazed_terracotta": "Light Blue Glazed Terracotta",
  "block.minecraft.light_blue_shulker_box": "Light Blue Shulker Box",
  "block.minecraft.light_blue_stained_glass": "Light Blue Stained Glass",
  "block.minecraft.light_blue_stained_glass_pane": "Light Blue Stained Glass Pane",
  "block.minecraft.light_blue_terracotta": "Light Blue Terracotta",
  "block.minecraft.light_blue_wool": "Light Blue Wool",
  "block.minecraft.light_gray_banner": "Light Grey Banner",
  "block.minecraft.light_gray_bed": "Light Grey Bed",
  "block.minecraft.light_gray_candle": "Light Grey Candle",
  "block.minecraft.light_gray_candle_cake": "Cake with Light Grey Candle",
  "block.minecraft.light_gray_carpet": "Light Grey Carpet",
  "block.minecraft.light_gray_concrete": "Light Grey Concrete",
  "block.minecraft.light_gray_concrete_powder": "Light Grey Concrete Powder",
  "block.minecraft.light_gray_glazed_terracotta": "Light Grey Glazed Terracotta",
  "block.minecraft.light_gray_shulker_box": "Light Grey Shulker Box",
  "block.minecraft.light_gray_stained_glass": "Light Grey Stained Glass",
  "block.minecraft.light_gray_stained_glass_pane": "Light Grey Stained Glass Pane",
  "block.minecraft.light_gray_terracotta": "Light Grey Terracotta",
  "block.minecraft.light_gray_wool": "Light Grey Wool",
  "block.minecraft.light_weighted_pressure_plate": "Light Weighted Pressure Plate",
  "block.minecraft.lightning_rod": "Lightning Rod",
  "block.minecraft.lilac": "Lilac",
  "block.minecraft.lily_of_the_valley": "Lily of the Valley",
  "block.minecraft.lily_pad": "Lily Pad",
  "block.minecraft.lime_banner": "Lime Banner",
  "block.minecraft.lime_bed": "Lime Bed",
  "block.minecraft.lime_candle": "Lime Candle",
  "block.minecraft.lime_candle_cake": "Cake with Lime Candle",
  "block.minecraft.lime_carpet": "Lime Carpet",
  "block.minecraft.lime_concrete": "Lime Concrete",
  "block.minecraft.lime_concrete_powder": "Lime Concrete Powder",
  "block.minecraft.lime_glazed_terracotta": "Lime Glazed Terracotta",
  "block.minecraft.lime_shulker_box": "Lime Shulker Box",
  "block.minecraft.lime_stained_glass": "Lime Stained Glass",
  "block.minecraft.lime_stained_glass_pane": "Lime Stained Glass Pane",
  "block.minecraft.lime_terracotta": "Lime Terracotta",
  "block.minecraft.lime_wool": "Lime Wool",
  "block.minecraft.lodestone": "Lodestone",
  "block.minecraft.loom": "Loom",
  "block.minecraft.magenta_banner": "Magenta Banner",
  "block.minecraft.magenta_bed": "Magenta Bed",
  "block.minecraft.magenta_candle": "Magenta Candle",
  "block.minecraft.magenta_candle_cake": "Cake with Magenta Candle",
  "block.minecraft.magenta_carpet": "Magenta Carpet",
  "block.minecraft.magenta_concrete": "Magenta Concrete",
  "block.minecraft.magenta_concrete_powder": "Magenta Concrete Powder",
  "block.minecraft.magenta_glazed_terracotta": "Magenta Glazed Terracotta",
  "block.minecraft.magenta_shulker_box": "Magenta Shulker Box",
  "block.minecraft.magenta_stained_glass": "Magenta Stained Glass",
  "block.minecraft.magenta_stained_glass_pane": "Magenta Stained Glass Pane",
  "block.minecraft.magenta_terracotta": "Magenta Terracotta",
  "block.minecraft.magenta_wool": "Magenta Wool",
  "block.minecraft.magma_block": "Magma Block",
  "block.minecraft.mangrove_button": "Mangrove Button",
  "block.minecraft.mangrove_door": "Mangrove Door",
  "block.minecraft.mangrove_fence": "Mangrove Fence",
  "block.minecraft.mangrove_fence_gate": "Mangrove Fence Gate",
  "block.minecraft.mangrove_hanging_sign": "Mangrove Hanging Sign",
  "block.minecraft.mangrove_leaves": "Mangrove Leaves",
  "block.minecraft.mangrove_log": "Mangrove Log",
  "block.minecraft.mangrove_planks": "Mangrove Planks",
  "block.minecraft.mangrove_pressure_plate": "Mangrove Pressure Plate",
  "block.minecraft.mangrove_propagule": "Mangrove Propagule",
  "block.minecraft.mangrove_roots": "Mangrove Roots",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "Mangrove Sign",
  "block.minecraft.mangrove_slab": "Mangrove Slab",
  "block.minecraft.mangrove_stairs": "Mangrove Stairs",
  "block.minecraft.mangrove_trapdoor": "Mangrove Trapdoor",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrove Wall Hanging Sign",
  "block.minecraft.mangrove_wall_sign": "Mangrove Wall Sign",
  "block.minecraft.mangrove_wood": "Mangrove Wood",
  "block.minecraft.medium_amethyst_bud": "Medium Amethyst Bud",
  "block.minecraft.melon": "Melon",
  "block.minecraft.melon_stem": "Melon Stem",
  "block.minecraft.moss_block": "Moss Block",
  "block.minecraft.moss_carpet": "Moss Carpet",
  "block.minecraft.mossy_cobblestone": "Mossy Cobblestone",
  "block.minecraft.mossy_cobblestone_slab": "Mossy Cobblestone Slab",
  "block.minecraft.mossy_cobblestone_stairs": "Mossy Cobblestone Stairs",
  "block.minecraft.mossy_cobblestone_wall": "Mossy Cobblestone Wall",
  "block.minecraft.mossy_stone_brick_slab": "Mossy Stone Brick Slab",
  "block.minecraft.mossy_stone_brick_stairs": "Mossy Stone Brick Stairs",
  "block.minecraft.mossy_stone_brick_wall": "Mossy Stone Brick Wall",
  "block.minecraft.mossy_stone_bricks": "Mossy Stone Bricks",
  "block.minecraft.moving_piston": "Moving Piston",
  "block.minecraft.mud": "Mud",
  "block.minecraft.mud_brick_slab": "Mud Brick Slab",
  "block.minecraft.mud_brick_stairs": "Mud Brick Stairs",
  "block.minecraft.mud_brick_wall": "Mud Brick Wall",
  "block.minecraft.mud_bricks": "Mud Bricks",
  "block.minecraft.muddy_mangrove_roots": "Muddy Mangrove Roots",
  "block.minecraft.mushroom_stem": "Mushroom Stem",
  "block.minecraft.mycelium": "Mycelium",
  "block.minecraft.nether_brick_fence": "Nether Brick Fence",
  "block.minecraft.nether_brick_slab": "Nether Brick Slab",
  "block.minecraft.nether_brick_stairs": "Nether Brick Stairs",
  "block.minecraft.nether_brick_wall": "Nether Brick Wall",
  "block.minecraft.nether_bricks": "Nether Bricks",
  "block.minecraft.nether_gold_ore": "Nether Gold Ore",
  "block.minecraft.nether_portal": "Nether Portal",
  "block.minecraft.nether_quartz_ore": "Nether Quartz Ore",
  "block.minecraft.nether_sprouts": "Nether Sprouts",
  "block.minecraft.nether_wart": "Nether Wart",
  "block.minecraft.nether_wart_block": "Nether Wart Block",
  "block.minecraft.netherite_block": "Block of Netherite",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Note Block",
  "block.minecraft.oak_button": "Oak Button",
  "block.minecraft.oak_door": "Oak Door",
  "block.minecraft.oak_fence": "Oak Fence",
  "block.minecraft.oak_fence_gate": "Oak Fence Gate",
  "block.minecraft.oak_hanging_sign": "Oak Hanging Sign",
  "block.minecraft.oak_leaves": "Oak Leaves",
  "block.minecraft.oak_log": "Oak Log",
  "block.minecraft.oak_planks": "Oak Planks",
  "block.minecraft.oak_pressure_plate": "Oak Pressure Plate",
  "block.minecraft.oak_sapling": "Oak Sapling",
  "block.minecraft.oak_shelf": "Oak Shelf",
  "block.minecraft.oak_sign": "Oak Sign",
  "block.minecraft.oak_slab": "Oak Slab",
  "block.minecraft.oak_stairs": "Oak Stairs",
  "block.minecraft.oak_trapdoor": "Oak Trapdoor",
  "block.minecraft.oak_wall_hanging_sign": "Oak Wall Hanging Sign",
  "block.minecraft.oak_wall_sign": "Oak Wall Sign",
  "block.minecraft.oak_wood": "Oak Wood",
  "block.minecraft.observer": "Observer",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Ochre Froglight",
  "block.minecraft.ominous_banner": "Ominous Banner",
  "block.minecraft.open_eyeblossom": "Open Eyeblossom",
  "block.minecraft.orange_banner": "Orange Banner",
  "block.minecraft.orange_bed": "Orange Bed",
  "block.minecraft.orange_candle": "Orange Candle",
  "block.minecraft.orange_candle_cake": "Cake with Orange Candle",
  "block.minecraft.orange_carpet": "Orange Carpet",
  "block.minecraft.orange_concrete": "Orange Concrete",
  "block.minecraft.orange_concrete_powder": "Orange Concrete Powder",
  "block.minecraft.orange_glazed_terracotta": "Orange Glazed Terracotta",
  "block.minecraft.orange_shulker_box": "Orange Shulker Box",
  "block.minecraft.orange_stained_glass": "Orange Stained Glass",
  "block.minecraft.orange_stained_glass_pane": "Orange Stained Glass Pane",
  "block.minecraft.orange_terracotta": "Orange Terracotta",
  "block.minecraft.orange_tulip": "Orange Tulip",
  "block.minecraft.orange_wool": "Orange Wool",
  "block.minecraft.oxeye_daisy": "Oxeye Daisy",
  "block.minecraft.oxidized_chiseled_copper": "Oxidised Chiselled Copper",
  "block.minecraft.oxidized_copper": "Oxidised Copper",
  "block.minecraft.oxidized_copper_bars": "Oxidised Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Oxidised Copper Bulb",
  "block.minecraft.oxidized_copper_chain": "Oxidised Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidised Copper Chest",
  "block.minecraft.oxidized_copper_door": "Oxidised Copper Door",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidised Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Oxidised Copper Grate",
  "block.minecraft.oxidized_copper_lantern": "Oxidised Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Oxidised Copper Trapdoor",
  "block.minecraft.oxidized_cut_copper": "Oxidised Cut Copper",
  "block.minecraft.oxidized_cut_copper_slab": "Oxidised Cut Copper Slab",
  "block.minecraft.oxidized_cut_copper_stairs": "Oxidised Cut Copper Stairs",
  "block.minecraft.oxidized_lightning_rod": "Oxidised Lightning Rod",
  "block.minecraft.packed_ice": "Compressed Ice",
  "block.minecraft.packed_mud": "Packed Mud",
  "block.minecraft.pale_hanging_moss": "Pale Hanging Moss",
  "block.minecraft.pale_moss_block": "Pale Moss Block",
  "block.minecraft.pale_moss_carpet": "Pale Moss Carpet",
  "block.minecraft.pale_oak_button": "Pale Oak Button",
  "block.minecraft.pale_oak_door": "Pale Oak Door",
  "block.minecraft.pale_oak_fence": "Pale Oak Fence",
  "block.minecraft.pale_oak_fence_gate": "Pale Oak Fence Gate",
  "block.minecraft.pale_oak_hanging_sign": "Pale Oak Hanging Sign",
  "block.minecraft.pale_oak_leaves": "Pale Oak Leaves",
  "block.minecraft.pale_oak_log": "Pale Oak Log",
  "block.minecraft.pale_oak_planks": "Pale Oak Planks",
  "block.minecraft.pale_oak_pressure_plate": "Pale Oak Pressure Plate",
  "block.minecraft.pale_oak_sapling": "Pale Oak Sapling",
  "block.minecraft.pale_oak_shelf": "Pale Oak Shelf",
  "block.minecraft.pale_oak_sign": "Pale Oak Sign",
  "block.minecraft.pale_oak_slab": "Pale Oak Slab",
  "block.minecraft.pale_oak_stairs": "Pale Oak Stairs",
  "block.minecraft.pale_oak_trapdoor": "Pale Oak Trapdoor",
  "block.minecraft.pale_oak_wall_hanging_sign": "Pale Oak Wall Hanging Sign",
  "block.minecraft.pale_oak_wall_sign": "Pale Oak Wall Sign",
  "block.minecraft.pale_oak_wood": "Pale Oak Wood",
  "block.minecraft.pearlescent_froglight": "Pearlescent Froglight",
  "block.minecraft.peony": "Peony",
  "block.minecraft.petrified_oak_slab": "Petrified Oak Slab",
  "block.minecraft.piglin_head": "Piglin Head",
  "block.minecraft.piglin_wall_head": "Piglin Wall Head",
  "block.minecraft.pink_banner": "Pink Banner",
  "block.minecraft.pink_bed": "Pink Bed",
  "block.minecraft.pink_candle": "Pink Candle",
  "block.minecraft.pink_candle_cake": "Cake with Pink Candle",
  "block.minecraft.pink_carpet": "Pink Carpet",
  "block.minecraft.pink_concrete": "Pink Concrete",
  "block.minecraft.pink_concrete_powder": "Pink Concrete Powder",
  "block.minecraft.pink_glazed_terracotta": "Pink Glazed Terracotta",
  "block.minecraft.pink_petals": "Pink Petals",
  "block.minecraft.pink_shulker_box": "Pink Shulker Box",
  "block.minecraft.pink_stained_glass": "Pink Stained Glass",
  "block.minecraft.pink_stained_glass_pane": "Pink Stained Glass Pane",
  "block.minecraft.pink_terracotta": "Pink Terracotta",
  "block.minecraft.pink_tulip": "Pink Tulip",
  "block.minecraft.pink_wool": "Pink Wool",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Piston Head",
  "block.minecraft.pitcher_crop": "Pitcher Crop",
  "block.minecraft.pitcher_plant": "Pitcher Plant",
  "block.minecraft.player_head": "Player Head",
  "block.minecraft.player_head.named": "%s's Head",
  "block.minecraft.player_wall_head": "Player Wall Head",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Pointed Dripstone",
  "block.minecraft.polished_andesite": "Polished Andesite",
  "block.minecraft.polished_andesite_slab": "Polished Andesite Slab",
  "block.minecraft.polished_andesite_stairs": "Polished Andesite Stairs",
  "block.minecraft.polished_basalt": "Polished Basalt",
  "block.minecraft.polished_blackstone": "Polished Blackstone",
  "block.minecraft.polished_blackstone_brick_slab": "Polished Blackstone Brick Slab",
  "block.minecraft.polished_blackstone_brick_stairs": "Polished Blackstone Brick Stairs",
  "block.minecraft.polished_blackstone_brick_wall": "Polished Blackstone Brick Wall",
  "block.minecraft.polished_blackstone_bricks": "Polished Blackstone Bricks",
  "block.minecraft.polished_blackstone_button": "Polished Blackstone Button",
  "block.minecraft.polished_blackstone_pressure_plate": "Polished Blackstone Pressure Plate",
  "block.minecraft.polished_blackstone_slab": "Polished Blackstone Slab",
  "block.minecraft.polished_blackstone_stairs": "Polished Blackstone Stairs",
  "block.minecraft.polished_blackstone_wall": "Polished Blackstone Wall",
  "block.minecraft.polished_deepslate": "Polished Deepslate",
  "block.minecraft.polished_deepslate_slab": "Polished Deepslate Slab",
  "block.minecraft.polished_deepslate_stairs": "Polished Deepslate Stairs",
  "block.minecraft.polished_deepslate_wall": "Polished Deepslate Wall",
  "block.minecraft.polished_diorite": "Polished Diorite",
  "block.minecraft.polished_diorite_slab": "Polished Diorite Slab",
  "block.minecraft.polished_diorite_stairs": "Polished Diorite Stairs",
  "block.minecraft.polished_granite": "Polished Granite",
  "block.minecraft.polished_granite_slab": "Polished Granite Slab",
  "block.minecraft.polished_granite_stairs": "Polished Granite Stairs",
  "block.minecraft.polished_tuff": "Polished Tuff",
  "block.minecraft.polished_tuff_slab": "Polished Tuff Slab",
  "block.minecraft.polished_tuff_stairs": "Polished Tuff Stairs",
  "block.minecraft.polished_tuff_wall": "Polished Tuff Wall",
  "block.minecraft.poppy": "Poppy",
  "block.minecraft.potatoes": "Potatoes",
  "block.minecraft.potted_acacia_sapling": "Potted Acacia Sapling",
  "block.minecraft.potted_allium": "Potted Allium",
  "block.minecraft.potted_azalea_bush": "Potted Azalea",
  "block.minecraft.potted_azure_bluet": "Potted Azure Bluet",
  "block.minecraft.potted_bamboo": "Potted Bamboo",
  "block.minecraft.potted_birch_sapling": "Potted Birch Sapling",
  "block.minecraft.potted_blue_orchid": "Potted Blue Orchid",
  "block.minecraft.potted_brown_mushroom": "Potted Brown Mushroom",
  "block.minecraft.potted_cactus": "Potted Cactus",
  "block.minecraft.potted_cherry_sapling": "Potted Cherry Sapling",
  "block.minecraft.potted_closed_eyeblossom": "Potted Closed Eyeblossom",
  "block.minecraft.potted_cornflower": "Potted Cornflower",
  "block.minecraft.potted_crimson_fungus": "Potted Crimson Fungus",
  "block.minecraft.potted_crimson_roots": "Potted Crimson Roots",
  "block.minecraft.potted_dandelion": "Potted Dandelion",
  "block.minecraft.potted_dark_oak_sapling": "Potted Dark Oak Sapling",
  "block.minecraft.potted_dead_bush": "Potted Dead Bush",
  "block.minecraft.potted_fern": "Potted Fern",
  "block.minecraft.potted_flowering_azalea_bush": "Potted Flowering Azalea",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Potted Jungle Sapling",
  "block.minecraft.potted_lily_of_the_valley": "Potted Lily of the Valley",
  "block.minecraft.potted_mangrove_propagule": "Potted Mangrove Propagule",
  "block.minecraft.potted_oak_sapling": "Potted Oak Sapling",
  "block.minecraft.potted_open_eyeblossom": "Potted Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "Potted Orange Tulip",
  "block.minecraft.potted_oxeye_daisy": "Potted Oxeye Daisy",
  "block.minecraft.potted_pale_oak_sapling": "Potted Pale Oak Sapling",
  "block.minecraft.potted_pink_tulip": "Potted Pink Tulip",
  "block.minecraft.potted_poppy": "Potted Poppy",
  "block.minecraft.potted_red_mushroom": "Potted Red Mushroom",
  "block.minecraft.potted_red_tulip": "Potted Red Tulip",
  "block.minecraft.potted_spruce_sapling": "Potted Spruce Sapling",
  "block.minecraft.potted_torchflower": "Potted Torchflower",
  "block.minecraft.potted_warped_fungus": "Potted Warped Fungus",
  "block.minecraft.potted_warped_roots": "Potted Warped Roots",
  "block.minecraft.potted_white_tulip": "Potted White Tulip",
  "block.minecraft.potted_wither_rose": "Potted Wither Rose",
  "block.minecraft.powder_snow": "Powder Snow",
  "block.minecraft.powder_snow_cauldron": "Powder Snow Cauldron",
  "block.minecraft.powered_rail": "Powered Rail",
  "block.minecraft.prismarine": "Prismarine",
  "block.minecraft.prismarine_brick_slab": "Prismarine Brick Slab",
  "block.minecraft.prismarine_brick_stairs": "Prismarine Brick Stairs",
  "block.minecraft.prismarine_bricks": "Prismarine Bricks",
  "block.minecraft.prismarine_slab": "Prismarine Slab",
  "block.minecraft.prismarine_stairs": "Prismarine Stairs",
  "block.minecraft.prismarine_wall": "Prismarine Wall",
  "block.minecraft.pumpkin": "Pumpkin",
  "block.minecraft.pumpkin_stem": "Pumpkin Stem",
  "block.minecraft.purple_banner": "Purple Banner",
  "block.minecraft.purple_bed": "Purple Bed",
  "block.minecraft.purple_candle": "Purple Candle",
  "block.minecraft.purple_candle_cake": "Cake with Purple Candle",
  "block.minecraft.purple_carpet": "Purple Carpet",
  "block.minecraft.purple_concrete": "Purple Concrete",
  "block.minecraft.purple_concrete_powder": "Purple Concrete Powder",
  "block.minecraft.purple_glazed_terracotta": "Purple Glazed Terracotta",
  "block.minecraft.purple_shulker_box": "Purple Shulker Box",
  "block.minecraft.purple_stained_glass": "Purple Stained Glass",
  "block.minecraft.purple_stained_glass_pane": "Purple Stained Glass Pane",
  "block.minecraft.purple_terracotta": "Purple Terracotta",
  "block.minecraft.purple_wool": "Purple Wool",
  "block.minecraft.purpur_block": "Purpur Block",
  "block.minecraft.purpur_pillar": "Purpur Pillar",
  "block.minecraft.purpur_slab": "Purpur Slab",
  "block.minecraft.purpur_stairs": "Purpur Stairs",
  "block.minecraft.quartz_block": "Block of Quartz",
  "block.minecraft.quartz_bricks": "Quartz Bricks",
  "block.minecraft.quartz_pillar": "Quartz Pillar",
  "block.minecraft.quartz_slab": "Quartz Slab",
  "block.minecraft.quartz_stairs": "Quartz Stairs",
  "block.minecraft.rail": "Rail",
  "block.minecraft.raw_copper_block": "Block of Raw Copper",
  "block.minecraft.raw_gold_block": "Block of Raw Gold",
  "block.minecraft.raw_iron_block": "Block of Raw Iron",
  "block.minecraft.red_banner": "Red Banner",
  "block.minecraft.red_bed": "Red Bed",
  "block.minecraft.red_candle": "Red Candle",
  "block.minecraft.red_candle_cake": "Cake with Red Candle",
  "block.minecraft.red_carpet": "Red Carpet",
  "block.minecraft.red_concrete": "Red Concrete",
  "block.minecraft.red_concrete_powder": "Red Concrete Powder",
  "block.minecraft.red_glazed_terracotta": "Red Glazed Terracotta",
  "block.minecraft.red_mushroom": "Red Mushroom",
  "block.minecraft.red_mushroom_block": "Red Mushroom Block",
  "block.minecraft.red_nether_brick_slab": "Red Nether Brick Slab",
  "block.minecraft.red_nether_brick_stairs": "Red Nether Brick Stairs",
  "block.minecraft.red_nether_brick_wall": "Red Nether Brick Wall",
  "block.minecraft.red_nether_bricks": "Red Nether Bricks",
  "block.minecraft.red_sand": "Red Sand",
  "block.minecraft.red_sandstone": "Red Sandstone",
  "block.minecraft.red_sandstone_slab": "Red Sandstone Slab",
  "block.minecraft.red_sandstone_stairs": "Red Sandstone Stairs",
  "block.minecraft.red_sandstone_wall": "Red Sandstone Wall",
  "block.minecraft.red_shulker_box": "Red Shulker Box",
  "block.minecraft.red_stained_glass": "Red Stained Glass",
  "block.minecraft.red_stained_glass_pane": "Red Stained Glass Pane",
  "block.minecraft.red_terracotta": "Red Terracotta",
  "block.minecraft.red_tulip": "Red Tulip",
  "block.minecraft.red_wool": "Red Wool",
  "block.minecraft.redstone_block": "Block of Redstone",
  "block.minecraft.redstone_lamp": "Redstone Lamp",
  "block.minecraft.redstone_ore": "Redstone Ore",
  "block.minecraft.redstone_torch": "Redstone Torch",
  "block.minecraft.redstone_wall_torch": "Redstone Wall Torch",
  "block.minecraft.redstone_wire": "Redstone Wire",
  "block.minecraft.reinforced_deepslate": "Reinforced Deepslate",
  "block.minecraft.repeater": "Redstone Repeater",
  "block.minecraft.repeating_command_block": "Repeating Command Block",
  "block.minecraft.resin_block": "Block of Resin",
  "block.minecraft.resin_brick_slab": "Resin Brick Slab",
  "block.minecraft.resin_brick_stairs": "Resin Brick Stairs",
  "block.minecraft.resin_brick_wall": "Resin Brick Wall",
  "block.minecraft.resin_bricks": "Resin Bricks",
  "block.minecraft.resin_clump": "Resin Clump",
  "block.minecraft.respawn_anchor": "Respawn Anchor",
  "block.minecraft.rooted_dirt": "Rooted Dirt",
  "block.minecraft.rose_bush": "Rose Bush",
  "block.minecraft.sand": "Sand",
  "block.minecraft.sandstone": "Sandstone",
  "block.minecraft.sandstone_slab": "Sandstone Slab",
  "block.minecraft.sandstone_stairs": "Sandstone Stairs",
  "block.minecraft.sandstone_wall": "Sandstone Wall",
  "block.minecraft.scaffolding": "Scaffolding",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk Catalyst",
  "block.minecraft.sculk_sensor": "Sculk Sensor",
  "block.minecraft.sculk_shrieker": "Sculk Shrieker",
  "block.minecraft.sculk_vein": "Sculk Vein",
  "block.minecraft.sea_lantern": "Sea Lantern",
  "block.minecraft.sea_pickle": "Sea Pickle",
  "block.minecraft.seagrass": "Seagrass",
  "block.minecraft.set_spawn": "Respawn point set",
  "block.minecraft.short_dry_grass": "Short Dry Grass",
  "block.minecraft.short_grass": "Short Grass",
  "block.minecraft.shroomlight": "Shroomlight",
  "block.minecraft.shulker_box": "Shulker Box",
  "block.minecraft.skeleton_skull": "Skeleton Skull",
  "block.minecraft.skeleton_wall_skull": "Skeleton Wall Skull",
  "block.minecraft.slime_block": "Slime Block",
  "block.minecraft.small_amethyst_bud": "Small Amethyst Bud",
  "block.minecraft.small_dripleaf": "Small Dripleaf",
  "block.minecraft.smithing_table": "Smithing Table",
  "block.minecraft.smoker": "Smoker",
  "block.minecraft.smooth_basalt": "Smooth Basalt",
  "block.minecraft.smooth_quartz": "Smooth Quartz Block",
  "block.minecraft.smooth_quartz_slab": "Smooth Quartz Slab",
  "block.minecraft.smooth_quartz_stairs": "Smooth Quartz Stairs",
  "block.minecraft.smooth_red_sandstone": "Smooth Red Sandstone",
  "block.minecraft.smooth_red_sandstone_slab": "Smooth Red Sandstone Slab",
  "block.minecraft.smooth_red_sandstone_stairs": "Smooth Red Sandstone Stairs",
  "block.minecraft.smooth_sandstone": "Smooth Sandstone",
  "block.minecraft.smooth_sandstone_slab": "Smooth Sandstone Slab",
  "block.minecraft.smooth_sandstone_stairs": "Smooth Sandstone Stairs",
  "block.minecraft.smooth_stone": "Smooth Stone",
  "block.minecraft.smooth_stone_slab": "Smooth Stone Slab",
  "block.minecraft.sniffer_egg": "Sniffer Egg",
  "block.minecraft.snow": "Snow",
  "block.minecraft.snow_block": "Snow Block",
  "block.minecraft.soul_campfire": "Soul Campfire",
  "block.minecraft.soul_fire": "Soul Fire",
  "block.minecraft.soul_lantern": "Soul Lantern",
  "block.minecraft.soul_sand": "Soul Sand",
  "block.minecraft.soul_soil": "Soul Soil",
  "block.minecraft.soul_torch": "Soul Torch",
  "block.minecraft.soul_wall_torch": "Soul Wall Torch",
  "block.minecraft.spawn.not_valid": "You have no home Bed or charged Respawn Anchor, or it was obstructed",
  "block.minecraft.spawner": "Monster Spawner",
  "block.minecraft.spawner.desc1": "Interact with Spawn Egg:",
  "block.minecraft.spawner.desc2": "Sets Mob Type",
  "block.minecraft.sponge": "Sponge",
  "block.minecraft.spore_blossom": "Spore Blossom",
  "block.minecraft.spruce_button": "Spruce Button",
  "block.minecraft.spruce_door": "Spruce Door",
  "block.minecraft.spruce_fence": "Spruce Fence",
  "block.minecraft.spruce_fence_gate": "Spruce Fence Gate",
  "block.minecraft.spruce_hanging_sign": "Spruce Hanging Sign",
  "block.minecraft.spruce_leaves": "Spruce Leaves",
  "block.minecraft.spruce_log": "Spruce Log",
  "block.minecraft.spruce_planks": "Spruce Planks",
  "block.minecraft.spruce_pressure_plate": "Spruce Pressure Plate",
  "block.minecraft.spruce_sapling": "Spruce Sapling",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "Spruce Sign",
  "block.minecraft.spruce_slab": "Spruce Slab",
  "block.minecraft.spruce_stairs": "Spruce Stairs",
  "block.minecraft.spruce_trapdoor": "Spruce Trapdoor",
  "block.minecraft.spruce_wall_hanging_sign": "Spruce Wall Hanging Sign",
  "block.minecraft.spruce_wall_sign": "Spruce Wall Sign",
  "block.minecraft.spruce_wood": "Spruce Wood",
  "block.minecraft.sticky_piston": "Sticky Piston",
  "block.minecraft.stone": "Stone",
  "block.minecraft.stone_brick_slab": "Stone Brick Slab",
  "block.minecraft.stone_brick_stairs": "Stone Brick Stairs",
  "block.minecraft.stone_brick_wall": "Stone Brick Wall",
  "block.minecraft.stone_bricks": "Stone Bricks",
  "block.minecraft.stone_button": "Stone Button",
  "block.minecraft.stone_pressure_plate": "Stone Pressure Plate",
  "block.minecraft.stone_slab": "Stone Slab",
  "block.minecraft.stone_stairs": "Stone Stairs",
  "block.minecraft.stonecutter": "Stonecutter",
  "block.minecraft.stripped_acacia_log": "Stripped Acacia Log",
  "block.minecraft.stripped_acacia_wood": "Stripped Acacia Wood",
  "block.minecraft.stripped_bamboo_block": "Block of Stripped Bamboo",
  "block.minecraft.stripped_birch_log": "Stripped Birch Log",
  "block.minecraft.stripped_birch_wood": "Stripped Birch Wood",
  "block.minecraft.stripped_cherry_log": "Stripped Cherry Log",
  "block.minecraft.stripped_cherry_wood": "Stripped Cherry Wood",
  "block.minecraft.stripped_crimson_hyphae": "Stripped Crimson Hyphae",
  "block.minecraft.stripped_crimson_stem": "Stripped Crimson Stem",
  "block.minecraft.stripped_dark_oak_log": "Stripped Dark Oak Log",
  "block.minecraft.stripped_dark_oak_wood": "Stripped Dark Oak Wood",
  "block.minecraft.stripped_jungle_log": "Stripped Jungle Log",
  "block.minecraft.stripped_jungle_wood": "Stripped Jungle Wood",
  "block.minecraft.stripped_mangrove_log": "Stripped Mangrove Log",
  "block.minecraft.stripped_mangrove_wood": "Stripped Mangrove Wood",
  "block.minecraft.stripped_oak_log": "Stripped Oak Log",
  "block.minecraft.stripped_oak_wood": "Stripped Oak Wood",
  "block.minecraft.stripped_pale_oak_log": "Stripped Pale Oak Log",
  "block.minecraft.stripped_pale_oak_wood": "Stripped Pale Oak Wood",
  "block.minecraft.stripped_spruce_log": "Stripped Spruce Log",
  "block.minecraft.stripped_spruce_wood": "Stripped Spruce Wood",
  "block.minecraft.stripped_warped_hyphae": "Stripped Warped Hyphae",
  "block.minecraft.stripped_warped_stem": "Stripped Warped Stem",
  "block.minecraft.structure_block": "Structure Block",
  "block.minecraft.structure_void": "Structure Void",
  "block.minecraft.sugar_cane": "Sugar Cane",
  "block.minecraft.sunflower": "Sunflower",
  "block.minecraft.suspicious_gravel": "Suspicious Gravel",
  "block.minecraft.suspicious_sand": "Suspicious Sand",
  "block.minecraft.sweet_berry_bush": "Sweet Berry Bush",
  "block.minecraft.tall_dry_grass": "Tall Dry Grass",
  "block.minecraft.tall_grass": "Tall Grass",
  "block.minecraft.tall_seagrass": "Tall Seagrass",
  "block.minecraft.target": "Target",
  "block.minecraft.terracotta": "Terracotta",
  "block.minecraft.test_block": "Test Block",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "Tinted Glass",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "Torch",
  "block.minecraft.torchflower": "Torchflower",
  "block.minecraft.torchflower_crop": "Torchflower Crop",
  "block.minecraft.trapped_chest": "Trapped Chest",
  "block.minecraft.trial_spawner": "Trial Spawner",
  "block.minecraft.tripwire": "Tripwire",
  "block.minecraft.tripwire_hook": "Tripwire Hook",
  "block.minecraft.tube_coral": "Tube Coral",
  "block.minecraft.tube_coral_block": "Tube Coral Block",
  "block.minecraft.tube_coral_fan": "Tube Coral Fan",
  "block.minecraft.tube_coral_wall_fan": "Tube Coral Wall Fan",
  "block.minecraft.tuff": "Tuff",
  "block.minecraft.tuff_brick_slab": "Tuff Brick Slab",
  "block.minecraft.tuff_brick_stairs": "Tuff Brick Stairs",
  "block.minecraft.tuff_brick_wall": "Tuff Brick Wall",
  "block.minecraft.tuff_bricks": "Tuff Bricks",
  "block.minecraft.tuff_slab": "Tuff Slab",
  "block.minecraft.tuff_stairs": "Tuff Stairs",
  "block.minecraft.tuff_wall": "Tuff Wall",
  "block.minecraft.turtle_egg": "Turtle Egg",
  "block.minecraft.twisting_vines": "Twisting Vines",
  "block.minecraft.twisting_vines_plant": "Twisting Vines Plant",
  "block.minecraft.vault": "Vault",
  "block.minecraft.verdant_froglight": "Verdant Froglight",
  "block.minecraft.vine": "Vines",
  "block.minecraft.void_air": "Void Air",
  "block.minecraft.wall_torch": "Wall Torch",
  "block.minecraft.warped_button": "Warped Button",
  "block.minecraft.warped_door": "Warped Door",
  "block.minecraft.warped_fence": "Warped Fence",
  "block.minecraft.warped_fence_gate": "Warped Fence Gate",
  "block.minecraft.warped_fungus": "Warped Fungus",
  "block.minecraft.warped_hanging_sign": "Warped Hanging Sign",
  "block.minecraft.warped_hyphae": "Warped Hyphae",
  "block.minecraft.warped_nylium": "Warped Nylium",
  "block.minecraft.warped_planks": "Warped Planks",
  "block.minecraft.warped_pressure_plate": "Warped Pressure Plate",
  "block.minecraft.warped_roots": "Warped Roots",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Warped Sign",
  "block.minecraft.warped_slab": "Warped Slab",
  "block.minecraft.warped_stairs": "Warped Stairs",
  "block.minecraft.warped_stem": "Warped Stem",
  "block.minecraft.warped_trapdoor": "Warped Trapdoor",
  "block.minecraft.warped_wall_hanging_sign": "Warped Wall Hanging Sign",
  "block.minecraft.warped_wall_sign": "Warped Wall Sign",
  "block.minecraft.warped_wart_block": "Warped Wart Block",
  "block.minecraft.water": "Water",
  "block.minecraft.water_cauldron": "Water Cauldron",
  "block.minecraft.waxed_chiseled_copper": "Waxed Chiselled Copper",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Waxed Block of Copper",
  "block.minecraft.waxed_copper_bulb": "Waxed Copper Bulb",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Waxed Copper Door",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Waxed Copper Grate",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Waxed Copper Trapdoor",
  "block.minecraft.waxed_cut_copper": "Waxed Cut Copper",
  "block.minecraft.waxed_cut_copper_slab": "Waxed Cut Copper Slab",
  "block.minecraft.waxed_cut_copper_stairs": "Waxed Cut Copper Stairs",
  "block.minecraft.waxed_exposed_chiseled_copper": "Waxed Exposed Chiselled Copper",
  "block.minecraft.waxed_exposed_copper": "Waxed Exposed Copper",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Waxed Exposed Copper Bulb",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Waxed Exposed Copper Door",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Waxed Exposed Copper Grate",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Waxed Exposed Copper Trapdoor",
  "block.minecraft.waxed_exposed_cut_copper": "Waxed Exposed Cut Copper",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Waxed Exposed Cut Copper Slab",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Waxed Exposed Cut Copper Stairs",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Waxed Oxidised Chiselled Copper",
  "block.minecraft.waxed_oxidized_copper": "Waxed Oxidised Copper",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidised Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Waxed Oxidised Copper Bulb",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidised Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidised Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Waxed Oxidised Copper Door",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidised Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Waxed Oxidised Copper Grate",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidised Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Waxed Oxidised Copper Trapdoor",
  "block.minecraft.waxed_oxidized_cut_copper": "Waxed Oxidised Cut Copper",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Waxed Oxidised Cut Copper Slab",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Waxed Oxidised Cut Copper Stairs",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidised Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Waxed Weathered Chiselled Copper",
  "block.minecraft.waxed_weathered_copper": "Waxed Weathered Copper",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Waxed Weathered Copper Bulb",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Waxed Weathered Copper Door",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Waxed Weathered Copper Grate",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Waxed Weathered Copper Trapdoor",
  "block.minecraft.waxed_weathered_cut_copper": "Waxed Weathered Cut Copper",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Waxed Weathered Cut Copper Slab",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Waxed Weathered Cut Copper Stairs",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Weathered Chiselled Copper",
  "block.minecraft.weathered_copper": "Weathered Copper",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Weathered Copper Bulb",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Weathered Copper Door",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Weathered Copper Grate",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Weathered Copper Trapdoor",
  "block.minecraft.weathered_cut_copper": "Weathered Cut Copper",
  "block.minecraft.weathered_cut_copper_slab": "Weathered Cut Copper Slab",
  "block.minecraft.weathered_cut_copper_stairs": "Weathered Cut Copper Stairs",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Weeping Vines",
  "block.minecraft.weeping_vines_plant": "Weeping Vines Plant",
  "block.minecraft.wet_sponge": "Wet Sponge",
  "block.minecraft.wheat": "Wheat Crops",
  "block.minecraft.white_banner": "White Banner",
  "block.minecraft.white_bed": "White Bed",
  "block.minecraft.white_candle": "White Candle",
  "block.minecraft.white_candle_cake": "Cake with White Candle",
  "block.minecraft.white_carpet": "White Carpet",
  "block.minecraft.white_concrete": "White Concrete",
  "block.minecraft.white_concrete_powder": "White Concrete Powder",
  "block.minecraft.white_glazed_terracotta": "White Glazed Terracotta",
  "block.minecraft.white_shulker_box": "White Shulker Box",
  "block.minecraft.white_stained_glass": "White Stained Glass",
  "block.minecraft.white_stained_glass_pane": "White Stained Glass Pane",
  "block.minecraft.white_terracotta": "White Terracotta",
  "block.minecraft.white_tulip": "White Tulip",
  "block.minecraft.white_wool": "White Wool",
  "block.minecraft.wildflowers": "Wildflowers",
  "block.minecraft.wither_rose": "Wither Rose",
  "block.minecraft.wither_skeleton_skull": "Wither Skeleton Skull",
  "block.minecraft.wither_skeleton_wall_skull": "Wither Skeleton Wall Skull",
  "block.minecraft.yellow_banner": "Yellow Banner",
  "block.minecraft.yellow_bed": "Yellow Bed",
  "block.minecraft.yellow_candle": "Yellow Candle",
  "block.minecraft.yellow_candle_cake": "Cake with Yellow Candle",
  "block.minecraft.yellow_carpet": "Yellow Carpet",
  "block.minecraft.yellow_concrete": "Yellow Concrete",
  "block.minecraft.yellow_concrete_powder": "Yellow Concrete Powder",
  "block.minecraft.yellow_glazed_terracotta": "Yellow Glazed Terracotta",
  "block.minecraft.yellow_shulker_box": "Yellow Shulker Box",
  "block.minecraft.yellow_stained_glass": "Yellow Stained Glass",
  "block.minecraft.yellow_stained_glass_pane": "Yellow Stained Glass Pane",
  "block.minecraft.yellow_terracotta": "Yellow Terracotta",
  "block.minecraft.yellow_wool": "Yellow Wool",
  "block.minecraft.zombie_head": "Zombie Head",
  "block.minecraft.zombie_wall_head": "Zombie Wall Head",
  "item.minecraft.acacia_boat": "Acacia Boat",
  "item.minecraft.acacia_chest_boat": "Acacia Boat with Chest",
  "item.minecraft.allay_spawn_egg": "Allay Spawn Egg",
  "item.minecraft.amethyst_shard": "Amethyst Shard",
  "item.minecraft.angler_pottery_shard": "Angler Pottery Shard",
  "item.minecraft.angler_pottery_sherd": "Angler Pottery Sherd",
  "item.minecraft.apple": "Apple",
  "item.minecraft.archer_pottery_shard": "Archer Pottery Shard",
  "item.minecraft.archer_pottery_sherd": "Archer Pottery Sherd",
  "item.minecraft.armadillo_scute": "Armadillo Scute",
  "item.minecraft.armadillo_spawn_egg": "Armadillo Spawn Egg",
  "item.minecraft.armor_stand": "Armour Stand",
  "item.minecraft.arms_up_pottery_shard": "Arms Up Pottery Shard",
  "item.minecraft.arms_up_pottery_sherd": "Arms Up Pottery Sherd",
  "item.minecraft.arrow": "Arrow",
  "item.minecraft.axolotl_bucket": "Bucket of Axolotl",
  "item.minecraft.axolotl_spawn_egg": "Axolotl Spawn Egg",
  "item.minecraft.baked_potato": "Jacket Potato",
  "item.minecraft.bamboo_chest_raft": "Bamboo Raft with Chest",
  "item.minecraft.bamboo_raft": "Bamboo Raft",
  "item.minecraft.bat_spawn_egg": "Bat Spawn Egg",
  "item.minecraft.bee_spawn_egg": "Bee Spawn Egg",
  "item.minecraft.beef": "Raw Beef",
  "item.minecraft.beetroot": "Beetroot",
  "item.minecraft.beetroot_seeds": "Beetroot Seeds",
  "item.minecraft.beetroot_soup": "Beetroot Soup",
  "item.minecraft.birch_boat": "Birch Boat",
  "item.minecraft.birch_chest_boat": "Birch Boat with Chest",
  "item.minecraft.black_bundle": "Black Bundle",
  "item.minecraft.black_dye": "Black Dye",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "Blade Pottery Shard",
  "item.minecraft.blade_pottery_sherd": "Blade Pottery Sherd",
  "item.minecraft.blaze_powder": "Blaze Powder",
  "item.minecraft.blaze_rod": "Blaze Rod",
  "item.minecraft.blaze_spawn_egg": "Blaze Spawn Egg",
  "item.minecraft.blue_bundle": "Blue Bundle",
  "item.minecraft.blue_dye": "Blue Dye",
  "item.minecraft.blue_egg": "Blue Egg",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Bogged Spawn Egg",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armour Trim",
  "item.minecraft.bone": "Bone",
  "item.minecraft.bone_meal": "Bone Meal",
  "item.minecraft.book": "Book",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "Bow",
  "item.minecraft.bowl": "Bowl",
  "item.minecraft.bread": "Bread",
  "item.minecraft.breeze_rod": "Breeze Rod",
  "item.minecraft.breeze_spawn_egg": "Breeze Spawn Egg",
  "item.minecraft.brewer_pottery_shard": "Brewer Pottery Shard",
  "item.minecraft.brewer_pottery_sherd": "Brewer Pottery Sherd",
  "item.minecraft.brewing_stand": "Brewing Stand",
  "item.minecraft.brick": "Brick",
  "item.minecraft.brown_bundle": "Brown Bundle",
  "item.minecraft.brown_dye": "Brown Dye",
  "item.minecraft.brown_egg": "Brown Egg",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "Brush",
  "item.minecraft.bucket": "Bucket",
  "item.minecraft.bundle": "Bundle",
  "item.minecraft.bundle.empty": "Empty",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Burn Pottery Shard",
  "item.minecraft.burn_pottery_sherd": "Burn Pottery Sherd",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Camel Spawn Egg",
  "item.minecraft.carrot": "Carrot",
  "item.minecraft.carrot_on_a_stick": "Carrot on a Stick",
  "item.minecraft.cat_spawn_egg": "Cat Spawn Egg",
  "item.minecraft.cauldron": "Cauldron",
  "item.minecraft.cave_spider_spawn_egg": "Cave Spider Spawn Egg",
  "item.minecraft.chainmail_boots": "Chainmail Boots",
  "item.minecraft.chainmail_chestplate": "Chainmail Chestplate",
  "item.minecraft.chainmail_helmet": "Chainmail Helmet",
  "item.minecraft.chainmail_leggings": "Chainmail Leggings",
  "item.minecraft.charcoal": "Charcoal",
  "item.minecraft.cherry_boat": "Cherry Boat",
  "item.minecraft.cherry_chest_boat": "Cherry Boat with Chest",
  "item.minecraft.chest_minecart": "Minecart with Chest",
  "item.minecraft.chicken": "Raw Chicken",
  "item.minecraft.chicken_spawn_egg": "Chicken Spawn Egg",
  "item.minecraft.chorus_fruit": "Chorus Fruit",
  "item.minecraft.clay_ball": "Clay Ball",
  "item.minecraft.clock": "Clock",
  "item.minecraft.coal": "Coal",
  "item.minecraft.coast_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armour Trim",
  "item.minecraft.cocoa_beans": "Cocoa Beans",
  "item.minecraft.cod": "Raw Cod",
  "item.minecraft.cod_bucket": "Bucket of Cod",
  "item.minecraft.cod_spawn_egg": "Cod Spawn Egg",
  "item.minecraft.command_block_minecart": "Minecart with Command Block",
  "item.minecraft.compass": "Compass",
  "item.minecraft.cooked_beef": "Steak",
  "item.minecraft.cooked_chicken": "Roast Chicken",
  "item.minecraft.cooked_cod": "Cooked Cod",
  "item.minecraft.cooked_mutton": "Cooked Mutton",
  "item.minecraft.cooked_porkchop": "Cooked Porkchop",
  "item.minecraft.cooked_rabbit": "Cooked Rabbit",
  "item.minecraft.cooked_salmon": "Cooked Salmon",
  "item.minecraft.cookie": "Biscuit",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armour",
  "item.minecraft.copper_ingot": "Copper Ingot",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armour",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Cow Spawn Egg",
  "item.minecraft.creaking_spawn_egg": "Creaking Spawn Egg",
  "item.minecraft.creeper_banner_pattern": "Banner Pattern",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper Charge",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "Creeper Spawn Egg",
  "item.minecraft.crossbow": "Crossbow",
  "item.minecraft.crossbow.projectile": "Projectile:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Cyan Bundle",
  "item.minecraft.cyan_dye": "Cyan Dye",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "Danger Pottery Shard",
  "item.minecraft.danger_pottery_sherd": "Danger Pottery Sherd",
  "item.minecraft.dark_oak_boat": "Dark Oak Boat",
  "item.minecraft.dark_oak_chest_boat": "Dark Oak Boat with Chest",
  "item.minecraft.debug_stick": "Debug Stick",
  "item.minecraft.debug_stick.empty": "%s has no properties",
  "item.minecraft.debug_stick.select": "selected \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" to %s",
  "item.minecraft.diamond": "Diamond",
  "item.minecraft.diamond_axe": "Diamond Axe",
  "item.minecraft.diamond_boots": "Diamond Boots",
  "item.minecraft.diamond_chestplate": "Diamond Chestplate",
  "item.minecraft.diamond_helmet": "Diamond Helmet",
  "item.minecraft.diamond_hoe": "Diamond Hoe",
  "item.minecraft.diamond_horse_armor": "Diamond Horse Armour",
  "item.minecraft.diamond_leggings": "Diamond Leggings",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armour",
  "item.minecraft.diamond_pickaxe": "Diamond Pickaxe",
  "item.minecraft.diamond_shovel": "Diamond Shovel",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Diamond Sword",
  "item.minecraft.disc_fragment_5": "Disc Fragment",
  "item.minecraft.disc_fragment_5.desc": "Music Disc - 5",
  "item.minecraft.dolphin_spawn_egg": "Dolphin Spawn Egg",
  "item.minecraft.donkey_spawn_egg": "Donkey Spawn Egg",
  "item.minecraft.dragon_breath": "Dragon's Breath",
  "item.minecraft.dried_kelp": "Dried Kelp",
  "item.minecraft.drowned_spawn_egg": "Drowned Spawn Egg",
  "item.minecraft.dune_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune Armour Trim",
  "item.minecraft.echo_shard": "Echo Shard",
  "item.minecraft.egg": "Egg",
  "item.minecraft.elder_guardian_spawn_egg": "Elder Guardian Spawn Egg",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "Emerald",
  "item.minecraft.enchanted_book": "Enchanted Book",
  "item.minecraft.enchanted_golden_apple": "Enchanted Golden Apple",
  "item.minecraft.end_crystal": "End Crystal",
  "item.minecraft.ender_dragon_spawn_egg": "Ender Dragon Spawn Egg",
  "item.minecraft.ender_eye": "Eye of Ender",
  "item.minecraft.ender_pearl": "Ender Pearl",
  "item.minecraft.enderman_spawn_egg": "Enderman Spawn Egg",
  "item.minecraft.endermite_spawn_egg": "Endermite Spawn Egg",
  "item.minecraft.evoker_spawn_egg": "Evoker Spawn Egg",
  "item.minecraft.experience_bottle": "Bottle o' Enchanting",
  "item.minecraft.explorer_pottery_shard": "Explorer Pottery Shard",
  "item.minecraft.explorer_pottery_sherd": "Explorer Pottery Sherd",
  "item.minecraft.eye_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye Armour Trim",
  "item.minecraft.feather": "Feather",
  "item.minecraft.fermented_spider_eye": "Fermented Spider Eye",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "Map",
  "item.minecraft.fire_charge": "Fire Charge",
  "item.minecraft.firework_rocket": "Firework Rocket",
  "item.minecraft.firework_rocket.flight": "Flight Duration:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Firework Star",
  "item.minecraft.firework_star.black": "Black",
  "item.minecraft.firework_star.blue": "Blue",
  "item.minecraft.firework_star.brown": "Brown",
  "item.minecraft.firework_star.custom_color": "Custom",
  "item.minecraft.firework_star.cyan": "Cyan",
  "item.minecraft.firework_star.fade_to": "Fade to",
  "item.minecraft.firework_star.flicker": "Twinkle",
  "item.minecraft.firework_star.gray": "Grey",
  "item.minecraft.firework_star.green": "Green",
  "item.minecraft.firework_star.light_blue": "Light Blue",
  "item.minecraft.firework_star.light_gray": "Light Grey",
  "item.minecraft.firework_star.lime": "Lime",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Orange",
  "item.minecraft.firework_star.pink": "Pink",
  "item.minecraft.firework_star.purple": "Purple",
  "item.minecraft.firework_star.red": "Red",
  "item.minecraft.firework_star.shape": "Unknown Shape",
  "item.minecraft.firework_star.shape.burst": "Burst",
  "item.minecraft.firework_star.shape.creeper": "Creeper-shaped",
  "item.minecraft.firework_star.shape.large_ball": "Large Ball",
  "item.minecraft.firework_star.shape.small_ball": "Small Ball",
  "item.minecraft.firework_star.shape.star": "Star-shaped",
  "item.minecraft.firework_star.trail": "Trail",
  "item.minecraft.firework_star.white": "White",
  "item.minecraft.firework_star.yellow": "Yellow",
  "item.minecraft.fishing_rod": "Fishing Rod",
  "item.minecraft.flint": "Flint",
  "item.minecraft.flint_and_steel": "Flint and Steel",
  "item.minecraft.flow_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armour Trim",
  "item.minecraft.flow_banner_pattern": "Banner Pattern",
  "item.minecraft.flow_banner_pattern.desc": "Flow",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Flow Pottery Sherd",
  "item.minecraft.flower_banner_pattern": "Banner Pattern",
  "item.minecraft.flower_banner_pattern.desc": "Flower Charge",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "Flower Pot",
  "item.minecraft.fox_spawn_egg": "Fox Spawn Egg",
  "item.minecraft.friend_pottery_shard": "Friend Pottery Shard",
  "item.minecraft.friend_pottery_sherd": "Friend Pottery Sherd",
  "item.minecraft.frog_spawn_egg": "Frog Spawn Egg",
  "item.minecraft.furnace_minecart": "Minecart with Furnace",
  "item.minecraft.ghast_spawn_egg": "Ghast Spawn Egg",
  "item.minecraft.ghast_tear": "Ghast Tear",
  "item.minecraft.glass_bottle": "Glass Bottle",
  "item.minecraft.glistering_melon_slice": "Glistering Melon Slice",
  "item.minecraft.globe_banner_pattern": "Banner Pattern",
  "item.minecraft.globe_banner_pattern.desc": "Globe",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "Glow Berries",
  "item.minecraft.glow_ink_sac": "Glow Ink Sac",
  "item.minecraft.glow_item_frame": "Glow Item Frame",
  "item.minecraft.glow_squid_spawn_egg": "Glow Squid Spawn Egg",
  "item.minecraft.glowstone_dust": "Glowstone Dust",
  "item.minecraft.goat_horn": "Goat Horn",
  "item.minecraft.goat_spawn_egg": "Goat Spawn Egg",
  "item.minecraft.gold_ingot": "Gold Ingot",
  "item.minecraft.gold_nugget": "Golden Nugget",
  "item.minecraft.golden_apple": "Golden Apple",
  "item.minecraft.golden_axe": "Golden Axe",
  "item.minecraft.golden_boots": "Golden Boots",
  "item.minecraft.golden_carrot": "Golden Carrot",
  "item.minecraft.golden_chestplate": "Golden Chestplate",
  "item.minecraft.golden_helmet": "Golden Helmet",
  "item.minecraft.golden_hoe": "Golden Hoe",
  "item.minecraft.golden_horse_armor": "Golden Horse Armour",
  "item.minecraft.golden_leggings": "Golden Leggings",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armour",
  "item.minecraft.golden_pickaxe": "Golden Pickaxe",
  "item.minecraft.golden_shovel": "Golden Shovel",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Golden Sword",
  "item.minecraft.gray_bundle": "Grey Bundle",
  "item.minecraft.gray_dye": "Grey Dye",
  "item.minecraft.gray_harness": "Grey Harness",
  "item.minecraft.green_bundle": "Green Bundle",
  "item.minecraft.green_dye": "Green Dye",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "Guardian Spawn Egg",
  "item.minecraft.gunpowder": "Gunpowder",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "Guster",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Spawn Egg",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "Heart of the Sea",
  "item.minecraft.heart_pottery_shard": "Heart Pottery Shard",
  "item.minecraft.heart_pottery_sherd": "Heart Pottery Sherd",
  "item.minecraft.heartbreak_pottery_shard": "Heartbreak Pottery Shard",
  "item.minecraft.heartbreak_pottery_sherd": "Heartbreak Pottery Sherd",
  "item.minecraft.hoglin_spawn_egg": "Hoglin Spawn Egg",
  "item.minecraft.honey_bottle": "Honey Bottle",
  "item.minecraft.honeycomb": "Honeycomb",
  "item.minecraft.hopper_minecart": "Minecart with Hopper",
  "item.minecraft.horse_spawn_egg": "Horse Spawn Egg",
  "item.minecraft.host_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armour Trim",
  "item.minecraft.howl_pottery_shard": "Howl Pottery Shard",
  "item.minecraft.howl_pottery_sherd": "Howl Pottery Sherd",
  "item.minecraft.husk_spawn_egg": "Husk Spawn Egg",
  "item.minecraft.ink_sac": "Ink Sac",
  "item.minecraft.iron_axe": "Iron Axe",
  "item.minecraft.iron_boots": "Iron Boots",
  "item.minecraft.iron_chestplate": "Iron Chestplate",
  "item.minecraft.iron_golem_spawn_egg": "Iron Golem Spawn Egg",
  "item.minecraft.iron_helmet": "Iron Helmet",
  "item.minecraft.iron_hoe": "Iron Hoe",
  "item.minecraft.iron_horse_armor": "Iron Horse Armour",
  "item.minecraft.iron_ingot": "Iron Ingot",
  "item.minecraft.iron_leggings": "Iron Leggings",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armour",
  "item.minecraft.iron_nugget": "Iron Nugget",
  "item.minecraft.iron_pickaxe": "Iron Pickaxe",
  "item.minecraft.iron_shovel": "Iron Shovel",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Iron Sword",
  "item.minecraft.item_frame": "Item Frame",
  "item.minecraft.jungle_boat": "Jungle Boat",
  "item.minecraft.jungle_chest_boat": "Jungle Boat with Chest",
  "item.minecraft.knowledge_book": "Knowledge Book",
  "item.minecraft.lapis_lazuli": "Lapis Lazuli",
  "item.minecraft.lava_bucket": "Lava Bucket",
  "item.minecraft.lead": "Lead",
  "item.minecraft.leather": "Leather",
  "item.minecraft.leather_boots": "Leather Boots",
  "item.minecraft.leather_chestplate": "Leather Tunic",
  "item.minecraft.leather_helmet": "Leather Hat",
  "item.minecraft.leather_horse_armor": "Leather Horse Armour",
  "item.minecraft.leather_leggings": "Leather Trousers",
  "item.minecraft.light_blue_bundle": "Light Blue Bundle",
  "item.minecraft.light_blue_dye": "Light Blue Dye",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Light Grey Bundle",
  "item.minecraft.light_gray_dye": "Light Grey Dye",
  "item.minecraft.light_gray_harness": "Light Grey Harness",
  "item.minecraft.lime_bundle": "Lime Bundle",
  "item.minecraft.lime_dye": "Lime Dye",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "Lingering Potion",
  "item.minecraft.lingering_potion.effect.awkward": "Awkward Lingering Potion",
  "item.minecraft.lingering_potion.effect.empty": "Lingering Uncraftable Potion",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Lingering Potion of Fire Resistance",
  "item.minecraft.lingering_potion.effect.harming": "Lingering Potion of Harming",
  "item.minecraft.lingering_potion.effect.healing": "Lingering Potion of Healing",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "Lingering Potion of Invisibility",
  "item.minecraft.lingering_potion.effect.leaping": "Lingering Potion of Leaping",
  "item.minecraft.lingering_potion.effect.levitation": "Lingering Potion of Levitation",
  "item.minecraft.lingering_potion.effect.luck": "Lingering Potion of Luck",
  "item.minecraft.lingering_potion.effect.mundane": "Mundane Lingering Potion",
  "item.minecraft.lingering_potion.effect.night_vision": "Lingering Potion of Night Vision",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "Lingering Potion of Poison",
  "item.minecraft.lingering_potion.effect.regeneration": "Lingering Potion of Regeneration",
  "item.minecraft.lingering_potion.effect.slow_falling": "Lingering Potion of Slow Falling",
  "item.minecraft.lingering_potion.effect.slowness": "Lingering Potion of Slowness",
  "item.minecraft.lingering_potion.effect.strength": "Lingering Potion of Strength",
  "item.minecraft.lingering_potion.effect.swiftness": "Lingering Potion of Swiftness",
  "item.minecraft.lingering_potion.effect.thick": "Thick Lingering Potion",
  "item.minecraft.lingering_potion.effect.turtle_master": "Lingering Potion of the Turtle Master",
  "item.minecraft.lingering_potion.effect.water": "Lingering Water Bottle",
  "item.minecraft.lingering_potion.effect.water_breathing": "Lingering Potion of Water Breathing",
  "item.minecraft.lingering_potion.effect.weakness": "Lingering Potion of Weakness",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "Llama Spawn Egg",
  "item.minecraft.lodestone_compass": "Lodestone Compass",
  "item.minecraft.mace": "Mace",
  "item.minecraft.magenta_bundle": "Magenta Bundle",
  "item.minecraft.magenta_dye": "Magenta Dye",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "Magma Cream",
  "item.minecraft.magma_cube_spawn_egg": "Magma Cube Spawn Egg",
  "item.minecraft.mangrove_boat": "Mangrove Boat",
  "item.minecraft.mangrove_chest_boat": "Mangrove Boat with Chest",
  "item.minecraft.map": "Empty Map",
  "item.minecraft.melon_seeds": "Melon Seeds",
  "item.minecraft.melon_slice": "Melon Slice",
  "item.minecraft.milk_bucket": "Milk Bucket",
  "item.minecraft.minecart": "Minecart",
  "item.minecraft.miner_pottery_shard": "Miner Pottery Shard",
  "item.minecraft.miner_pottery_sherd": "Miner Pottery Sherd",
  "item.minecraft.mojang_banner_pattern": "Banner Pattern",
  "item.minecraft.mojang_banner_pattern.desc": "Thing",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom Spawn Egg",
  "item.minecraft.mourner_pottery_shard": "Mourner Pottery Shard",
  "item.minecraft.mourner_pottery_sherd": "Mourner Pottery Sherd",
  "item.minecraft.mule_spawn_egg": "Mule Spawn Egg",
  "item.minecraft.mushroom_stew": "Mushroom Stew",
  "item.minecraft.music_disc_11": "Music Disc",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Music Disc",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Music Disc",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Music Disc",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Music Disc",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Music Disc",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Music Disc",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Music Disc",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Musical Box)",
  "item.minecraft.music_disc_far": "Music Disc",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Music Disc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Music Disc",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Music Disc",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Music Disc",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Music Disc",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Music Disc",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Music Disc",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Music Disc",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Music Disc",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Music Disc",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Music Disc",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Raw Mutton",
  "item.minecraft.name_tag": "Name Tag",
  "item.minecraft.nautilus_shell": "Nautilus Shell",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Nether Brick",
  "item.minecraft.nether_star": "Nether Star",
  "item.minecraft.nether_wart": "Nether Wart",
  "item.minecraft.netherite_axe": "Netherite Axe",
  "item.minecraft.netherite_boots": "Netherite Boots",
  "item.minecraft.netherite_chestplate": "Netherite Chestplate",
  "item.minecraft.netherite_helmet": "Netherite Helmet",
  "item.minecraft.netherite_hoe": "Netherite Hoe",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armour",
  "item.minecraft.netherite_ingot": "Netherite Ingot",
  "item.minecraft.netherite_leggings": "Netherite Leggings",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armour",
  "item.minecraft.netherite_pickaxe": "Netherite Pickaxe",
  "item.minecraft.netherite_scrap": "Netherite Scrap",
  "item.minecraft.netherite_shovel": "Netherite Shovel",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Netherite Sword",
  "item.minecraft.netherite_upgrade_smithing_template": "Smithing Template",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Upgrade",
  "item.minecraft.oak_boat": "Oak Boat",
  "item.minecraft.oak_chest_boat": "Oak Boat with Chest",
  "item.minecraft.ocelot_spawn_egg": "Ocelot Spawn Egg",
  "item.minecraft.ominous_bottle": "Ominous Bottle",
  "item.minecraft.ominous_trial_key": "Ominous Trial Key",
  "item.minecraft.orange_bundle": "Orange Bundle",
  "item.minecraft.orange_dye": "Orange Dye",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "Painting",
  "item.minecraft.pale_oak_boat": "Pale Oak Boat",
  "item.minecraft.pale_oak_chest_boat": "Pale Oak Boat with Chest",
  "item.minecraft.panda_spawn_egg": "Panda Spawn Egg",
  "item.minecraft.paper": "Paper",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Parrot Spawn Egg",
  "item.minecraft.phantom_membrane": "Phantom Membrane",
  "item.minecraft.phantom_spawn_egg": "Phantom Spawn Egg",
  "item.minecraft.pig_spawn_egg": "Pig Spawn Egg",
  "item.minecraft.piglin_banner_pattern": "Banner Pattern",
  "item.minecraft.piglin_banner_pattern.desc": "Snout",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "Piglin Brute Spawn Egg",
  "item.minecraft.piglin_spawn_egg": "Piglin Spawn Egg",
  "item.minecraft.pillager_spawn_egg": "Pillager Spawn Egg",
  "item.minecraft.pink_bundle": "Pink Bundle",
  "item.minecraft.pink_dye": "Pink Dye",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "Pitcher Plant",
  "item.minecraft.pitcher_pod": "Pitcher Pod",
  "item.minecraft.plenty_pottery_shard": "Plenty Pottery Shard",
  "item.minecraft.plenty_pottery_sherd": "Plenty Pottery Sherd",
  "item.minecraft.poisonous_potato": "Poisonous Potato",
  "item.minecraft.polar_bear_spawn_egg": "Polar Bear Spawn Egg",
  "item.minecraft.popped_chorus_fruit": "Popped Chorus Fruit",
  "item.minecraft.porkchop": "Raw Porkchop",
  "item.minecraft.potato": "Potato",
  "item.minecraft.potion": "Potion",
  "item.minecraft.potion.effect.awkward": "Awkward Potion",
  "item.minecraft.potion.effect.empty": "Uncraftable Potion",
  "item.minecraft.potion.effect.fire_resistance": "Potion of Fire Resistance",
  "item.minecraft.potion.effect.harming": "Potion of Harming",
  "item.minecraft.potion.effect.healing": "Potion of Healing",
  "item.minecraft.potion.effect.infested": "Potion of Infestation",
  "item.minecraft.potion.effect.invisibility": "Potion of Invisibility",
  "item.minecraft.potion.effect.leaping": "Potion of Leaping",
  "item.minecraft.potion.effect.levitation": "Potion of Levitation",
  "item.minecraft.potion.effect.luck": "Potion of Luck",
  "item.minecraft.potion.effect.mundane": "Mundane Potion",
  "item.minecraft.potion.effect.night_vision": "Potion of Night Vision",
  "item.minecraft.potion.effect.oozing": "Potion of Oozing",
  "item.minecraft.potion.effect.poison": "Potion of Poison",
  "item.minecraft.potion.effect.regeneration": "Potion of Regeneration",
  "item.minecraft.potion.effect.slow_falling": "Potion of Slow Falling",
  "item.minecraft.potion.effect.slowness": "Potion of Slowness",
  "item.minecraft.potion.effect.strength": "Potion of Strength",
  "item.minecraft.potion.effect.swiftness": "Potion of Swiftness",
  "item.minecraft.potion.effect.thick": "Thick Potion",
  "item.minecraft.potion.effect.turtle_master": "Potion of the Turtle Master",
  "item.minecraft.potion.effect.water": "Water Bottle",
  "item.minecraft.potion.effect.water_breathing": "Potion of Water Breathing",
  "item.minecraft.potion.effect.weakness": "Potion of Weakness",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "Archer Pottery Shard",
  "item.minecraft.pottery_shard_arms_up": "Arms Up Pottery Shard",
  "item.minecraft.pottery_shard_prize": "Prize Pottery Shard",
  "item.minecraft.pottery_shard_skull": "Skull Pottery Shard",
  "item.minecraft.powder_snow_bucket": "Powder Snow Bucket",
  "item.minecraft.prismarine_crystals": "Prismarine Crystals",
  "item.minecraft.prismarine_shard": "Prismarine Shard",
  "item.minecraft.prize_pottery_shard": "Prize Pottery Shard",
  "item.minecraft.prize_pottery_sherd": "Prize Pottery Sherd",
  "item.minecraft.pufferfish": "Pufferfish",
  "item.minecraft.pufferfish_bucket": "Bucket of Pufferfish",
  "item.minecraft.pufferfish_spawn_egg": "Pufferfish Spawn Egg",
  "item.minecraft.pumpkin_pie": "Pumpkin Pie",
  "item.minecraft.pumpkin_seeds": "Pumpkin Seeds",
  "item.minecraft.purple_bundle": "Purple Bundle",
  "item.minecraft.purple_dye": "Purple Dye",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "Nether Quartz",
  "item.minecraft.rabbit": "Raw Rabbit",
  "item.minecraft.rabbit_foot": "Rabbit's Foot",
  "item.minecraft.rabbit_hide": "Rabbit Hide",
  "item.minecraft.rabbit_spawn_egg": "Rabbit Spawn Egg",
  "item.minecraft.rabbit_stew": "Rabbit Stew",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armour Trim",
  "item.minecraft.ravager_spawn_egg": "Ravager Spawn Egg",
  "item.minecraft.raw_copper": "Raw Copper",
  "item.minecraft.raw_gold": "Raw Gold",
  "item.minecraft.raw_iron": "Raw Iron",
  "item.minecraft.recovery_compass": "Recovery Compass",
  "item.minecraft.red_bundle": "Red Bundle",
  "item.minecraft.red_dye": "Red Dye",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "Redstone Dust",
  "item.minecraft.resin_brick": "Resin Brick",
  "item.minecraft.resin_clump": "Resin Clump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armour Trim",
  "item.minecraft.rotten_flesh": "Rotten Flesh",
  "item.minecraft.saddle": "Saddle",
  "item.minecraft.salmon": "Raw Salmon",
  "item.minecraft.salmon_bucket": "Bucket of Salmon",
  "item.minecraft.salmon_spawn_egg": "Salmon Spawn Egg",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Scute",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armour Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armour Trim",
  "item.minecraft.sheaf_pottery_shard": "Sheaf Pottery Shard",
  "item.minecraft.sheaf_pottery_sherd": "Sheaf Pottery Sherd",
  "item.minecraft.shears": "Shears",
  "item.minecraft.sheep_spawn_egg": "Sheep Spawn Egg",
  "item.minecraft.shelter_pottery_shard": "Shelter Pottery Shard",
  "item.minecraft.shelter_pottery_sherd": "Shelter Pottery Sherd",
  "item.minecraft.shield": "Shield",
  "item.minecraft.shield.black": "Black Shield",
  "item.minecraft.shield.blue": "Blue Shield",
  "item.minecraft.shield.brown": "Brown Shield",
  "item.minecraft.shield.cyan": "Cyan Shield",
  "item.minecraft.shield.gray": "Grey Shield",
  "item.minecraft.shield.green": "Green Shield",
  "item.minecraft.shield.light_blue": "Light Blue Shield",
  "item.minecraft.shield.light_gray": "Light Grey Shield",
  "item.minecraft.shield.lime": "Lime Shield",
  "item.minecraft.shield.magenta": "Magenta Shield",
  "item.minecraft.shield.orange": "Orange Shield",
  "item.minecraft.shield.pink": "Pink Shield",
  "item.minecraft.shield.purple": "Purple Shield",
  "item.minecraft.shield.red": "Red Shield",
  "item.minecraft.shield.white": "White Shield",
  "item.minecraft.shield.yellow": "Yellow Shield",
  "item.minecraft.shulker_shell": "Shulker Shell",
  "item.minecraft.shulker_spawn_egg": "Shulker Spawn Egg",
  "item.minecraft.sign": "Sign",
  "item.minecraft.silence_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armour Trim",
  "item.minecraft.silverfish_spawn_egg": "Silverfish Spawn Egg",
  "item.minecraft.skeleton_horse_spawn_egg": "Skeleton Horse Spawn Egg",
  "item.minecraft.skeleton_spawn_egg": "Skeleton Spawn Egg",
  "item.minecraft.skull_banner_pattern": "Banner Pattern",
  "item.minecraft.skull_banner_pattern.desc": "Skull Charge",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Skull Pottery Shard",
  "item.minecraft.skull_pottery_sherd": "Skull Pottery Sherd",
  "item.minecraft.slime_ball": "Slimeball",
  "item.minecraft.slime_spawn_egg": "Slime Spawn Egg",
  "item.minecraft.smithing_template": "Smithing Template",
  "item.minecraft.smithing_template.applies_to": "Applies to:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Add an ingot or a crystal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armour",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Add a piece of armour",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Ingots & Crystals",
  "item.minecraft.smithing_template.ingredients": "Ingredients:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Add a Netherite Ingot",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamond Equipment",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Add diamond armour, a weapon or a tool",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherite Ingot",
  "item.minecraft.smithing_template.upgrade": "Upgrade: ",
  "item.minecraft.sniffer_spawn_egg": "Sniffer Spawn Egg",
  "item.minecraft.snort_pottery_shard": "Snort Pottery Shard",
  "item.minecraft.snort_pottery_sherd": "Snort Pottery Sherd",
  "item.minecraft.snout_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armour Trim",
  "item.minecraft.snow_golem_spawn_egg": "Snow Golem Spawn Egg",
  "item.minecraft.snowball": "Snowball",
  "item.minecraft.spectral_arrow": "Spectral Arrow",
  "item.minecraft.spider_eye": "Spider Eye",
  "item.minecraft.spider_spawn_egg": "Spider Spawn Egg",
  "item.minecraft.spire_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armour Trim",
  "item.minecraft.splash_potion": "Splash Potion",
  "item.minecraft.splash_potion.effect.awkward": "Awkward Splash Potion",
  "item.minecraft.splash_potion.effect.empty": "Splash Uncraftable Potion",
  "item.minecraft.splash_potion.effect.fire_resistance": "Splash Potion of Fire Resistance",
  "item.minecraft.splash_potion.effect.harming": "Splash Potion of Harming",
  "item.minecraft.splash_potion.effect.healing": "Splash Potion of Healing",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion of Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "Splash Potion of Invisibility",
  "item.minecraft.splash_potion.effect.leaping": "Splash Potion of Leaping",
  "item.minecraft.splash_potion.effect.levitation": "Splash Potion of Levitation",
  "item.minecraft.splash_potion.effect.luck": "Splash Potion of Luck",
  "item.minecraft.splash_potion.effect.mundane": "Mundane Splash Potion",
  "item.minecraft.splash_potion.effect.night_vision": "Splash Potion of Night Vision",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "Splash Potion of Poison",
  "item.minecraft.splash_potion.effect.regeneration": "Splash Potion of Regeneration",
  "item.minecraft.splash_potion.effect.slow_falling": "Splash Potion of Slow Falling",
  "item.minecraft.splash_potion.effect.slowness": "Splash Potion of Slowness",
  "item.minecraft.splash_potion.effect.strength": "Splash Potion of Strength",
  "item.minecraft.splash_potion.effect.swiftness": "Splash Potion of Swiftness",
  "item.minecraft.splash_potion.effect.thick": "Thick Splash Potion",
  "item.minecraft.splash_potion.effect.turtle_master": "Splash Potion of the Turtle Master",
  "item.minecraft.splash_potion.effect.water": "Splash Water Bottle",
  "item.minecraft.splash_potion.effect.water_breathing": "Splash Potion of Water Breathing",
  "item.minecraft.splash_potion.effect.weakness": "Splash Potion of Weakness",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "Spruce Boat",
  "item.minecraft.spruce_chest_boat": "Spruce Boat with Chest",
  "item.minecraft.spyglass": "Spyglass",
  "item.minecraft.squid_spawn_egg": "Squid Spawn Egg",
  "item.minecraft.stick": "Stick",
  "item.minecraft.stone_axe": "Stone Axe",
  "item.minecraft.stone_hoe": "Stone Hoe",
  "item.minecraft.stone_pickaxe": "Stone Pickaxe",
  "item.minecraft.stone_shovel": "Stone Shovel",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Stone Sword",
  "item.minecraft.stray_spawn_egg": "Stray Spawn Egg",
  "item.minecraft.strider_spawn_egg": "Strider Spawn Egg",
  "item.minecraft.string": "String",
  "item.minecraft.sugar": "Sugar",
  "item.minecraft.suspicious_stew": "Suspicious Stew",
  "item.minecraft.sweet_berries": "Sweet Berries",
  "item.minecraft.tadpole_bucket": "Bucket of Tadpole",
  "item.minecraft.tadpole_spawn_egg": "Tadpole Spawn Egg",
  "item.minecraft.tide_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armour Trim",
  "item.minecraft.tipped_arrow": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.awkward": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.empty": "Uncraftable Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Arrow of Fire Resistance",
  "item.minecraft.tipped_arrow.effect.harming": "Arrow of Harming",
  "item.minecraft.tipped_arrow.effect.healing": "Arrow of Healing",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "Arrow of Invisibility",
  "item.minecraft.tipped_arrow.effect.leaping": "Arrow of Leaping",
  "item.minecraft.tipped_arrow.effect.levitation": "Arrow of Levitation",
  "item.minecraft.tipped_arrow.effect.luck": "Arrow of Luck",
  "item.minecraft.tipped_arrow.effect.mundane": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.night_vision": "Arrow of Night Vision",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "Arrow of Poison",
  "item.minecraft.tipped_arrow.effect.regeneration": "Arrow of Regeneration",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Arrow of Slow Falling",
  "item.minecraft.tipped_arrow.effect.slowness": "Arrow of Slowness",
  "item.minecraft.tipped_arrow.effect.strength": "Arrow of Strength",
  "item.minecraft.tipped_arrow.effect.swiftness": "Arrow of Swiftness",
  "item.minecraft.tipped_arrow.effect.thick": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Arrow of the Turtle Master",
  "item.minecraft.tipped_arrow.effect.water": "Arrow of Splashing",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Arrow of Water Breathing",
  "item.minecraft.tipped_arrow.effect.weakness": "Arrow of Weakness",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "Minecart with TNT",
  "item.minecraft.torchflower_seeds": "Torchflower Seeds",
  "item.minecraft.totem_of_undying": "Totem of Undying",
  "item.minecraft.trader_llama_spawn_egg": "Trader Llama Spawn Egg",
  "item.minecraft.trial_key": "Trial Key",
  "item.minecraft.trident": "Trident",
  "item.minecraft.tropical_fish": "Tropical Fish",
  "item.minecraft.tropical_fish_bucket": "Bucket of Tropical Fish",
  "item.minecraft.tropical_fish_spawn_egg": "Tropical Fish Spawn Egg",
  "item.minecraft.turtle_helmet": "Turtle Shell",
  "item.minecraft.turtle_scute": "Turtle Scute",
  "item.minecraft.turtle_spawn_egg": "Turtle Spawn Egg",
  "item.minecraft.vex_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armour Trim",
  "item.minecraft.vex_spawn_egg": "Vex Spawn Egg",
  "item.minecraft.villager_spawn_egg": "Villager Spawn Egg",
  "item.minecraft.vindicator_spawn_egg": "Vindicator Spawn Egg",
  "item.minecraft.wandering_trader_spawn_egg": "Wandering Trader Spawn Egg",
  "item.minecraft.ward_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armour Trim",
  "item.minecraft.warden_spawn_egg": "Warden Spawn Egg",
  "item.minecraft.warped_fungus_on_a_stick": "Warped Fungus on a Stick",
  "item.minecraft.water_bucket": "Water Bucket",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armour Trim",
  "item.minecraft.wheat": "Wheat",
  "item.minecraft.wheat_seeds": "Wheat Seeds",
  "item.minecraft.white_bundle": "White Bundle",
  "item.minecraft.white_dye": "White Dye",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armour Trim",
  "item.minecraft.wind_charge": "Wind Charge",
  "item.minecraft.witch_spawn_egg": "Witch Spawn Egg",
  "item.minecraft.wither_skeleton_spawn_egg": "Wither Skeleton Spawn Egg",
  "item.minecraft.wither_spawn_egg": "Wither Spawn Egg",
  "item.minecraft.wolf_armor": "Wolf Armour",
  "item.minecraft.wolf_spawn_egg": "Wolf Spawn Egg",
  "item.minecraft.wooden_axe": "Wooden Axe",
  "item.minecraft.wooden_hoe": "Wooden Hoe",
  "item.minecraft.wooden_pickaxe": "Wooden Pickaxe",
  "item.minecraft.wooden_shovel": "Wooden Shovel",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "Wooden Sword",
  "item.minecraft.writable_book": "Book and Quill",
  "item.minecraft.written_book": "Written Book",
  "item.minecraft.yellow_bundle": "Yellow Bundle",
  "item.minecraft.yellow_dye": "Yellow Dye",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "Zoglin Spawn Egg",
  "item.minecraft.zombie_horse_spawn_egg": "Zombie Horse Spawn Egg",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Zombie Spawn Egg",
  "item.minecraft.zombie_villager_spawn_egg": "Zombie Villager Spawn Egg",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombified Piglin Spawn Egg"
}
export const en_gb = items; 
